// Kannada translations for the business management application
export default {
  // Landing page translations
  landing: {
    hero: {
      badge: 'ಭಾರತೀಯ SMEಗಳಿಗಾಗಿ',
      title: 'ನಿಮ್ಮ ವ್ಯಾಪಾರವನ್ನು ನಡೆಸಿ.',
      subtitle: 'ಕಾಗದದ ಕೆಲಸವಲ್ಲ.',
      description: 'ಭಾರತೀಯ SMEಗಳಿಗಾಗಿ ಮುಂಬರುವ ಎಂಟರ್‌ಪ್ರೈಸ್ OS. ಸ್ಥಳೀಯ-ಮೊದಲ ಐಷಾರಾಮಿಯೊಂದಿಗೆ GST, ಇನ್ವೆಂಟರಿ ಮತ್ತು ವ್ಯಾಪಾರ ಹಣಕಾಸನ್ನು ಸುಗಮಗೊಳಿಸಿ.',
      cta_waitlist: 'ವೈಟ್‌ಲಿಸ್ಟ್ ಸೇರಿ',
      cta_demo: 'ಆರ್ಕಿಟೆಕ್ಚರ್ ವೀಕ್ಷಿಸಿ',
      trust_early: 'ಶೀಘ್ರದಲ್ಲೇ ಆರಂಭಿಕ ಪ್ರವೇಶ',
      trust_card: 'ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಬೇಕಿಲ್ಲ',
      trust_gst: 'GST ಕೇಂದ್ರೀಕೃತ',
      stats_revenue: 'ಆದಾಯ',
      stats_inventory: 'ದಾಸ್ತಾನು'
    },
    social_proof: {
      stats: {
        smes: { value: 'ಭಾರತೀಯ SMEಗಳು', label: 'ನಿರ್ಮಿಸುತ್ತಿರುವುದು' },
        gst: { value: 'GST ಕೇಂದ್ರಿತ', label: 'ಅನುಸರಣೆ' },
        cloud: { value: 'ಕ್ಲೌಡ್ ನೇಟಿವ್', label: 'ಆರ್ಕಿಟೆಕ್ಚರ್' },
        status: { value: 'ಆರಂಭಿಕ ಪ್ರವೇಶ', label: 'ಸ್ಥಿತಿ' }
      }
    },
    problem: {
      badge: 'ಗಂಭೀರ ಸವಾಲುಗಳು',
      title: 'ನಿಮ್ಮ ಸ್ಕೇಲ್ ಅನ್ನು',
      subtitle: 'ತಡೆಹಿಡಿಯುತ್ತಿರುವ ಘರ್ಷಣೆ.',
      description: "ಆಧುನಿಕ ಭಾರತೀಯ ವ್ಯಾಪಾರ ಭೂದೃಶ್ಯ ವೇಗವಾಗಿ ವಿಕಸನಗೊಳ್ಳುತ್ತಿದೆ. ಲೆಗಸಿ ಪರಿಕರಗಳು ಡಿಜಿಟಲ್ ವಾಣಿಜ್ಯ ಮತ್ತು GST ಸಂಕೀರ್ಣತೆಯ ವೇಗಕ್ಕಾಗಿ ನಿರ್ಮಿಸಲಾಗಿಲ್ಲ.",
      cards: {
        paperwork: {
          title: 'ಕಾಗದದ ಕೆಲಸದಲ್ಲಿ ಕಳೆದುಹೋದ ಗಂಟೆಗಳು',
          description: 'ಹಸ್ತಚಾಲಿತ ಇನ್ವಾಯ್ಸಿಂಗ್, ಡೇಟಾ ಎಂಟ್ರಿ ಮತ್ತು ಹೊಂದಾಣಿಕೆ ಪ್ರತಿ ವಾರ 15+ ಗಂಟೆಗಳನ್ನು ತಿನ್ನುತ್ತವೆ. ನೀವು ಬೆಳವಣಿಗೆಯ ಮೇಲೆ ಕಳೆಯಬೇಕಾದ ಸಮಯ.'
        },
        gst: {
          title: 'GST ಅನುಸರಣೆ ತಲೆನೋವು',
          description: 'ಸರಿಯಾದ ತೆರಿಗೆ ದರಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡುವುದು, ಸಮಯಕ್ಕೆ ರಿಟರ್ನ್ಸ್ ಸಲ್ಲಿಸುವುದು ಮತ್ತು ದಂಡಗಳನ್ನು ತಪ್ಪಿಸುವುದು ನಿರಂತರ ತಾಂತ್ರಿಕ ಮತ್ತು ಮಾನಸಿಕ ಡ್ರೈನ್.'
        },
        inventory: {
          title: 'ಇನ್ವೆಂಟರಿ ಬ್ಲೈಂಡ್ ಸ್ಪಾಟ್ಸ್',
          description: "ಸ್ಟಾಕ್‌ಔಟ್‌ಗಳು ಮತ್ತು ಓವರ್‌ಸ್ಟಾಕಿಂಗ್ ಸಂಭವಿಸುತ್ತವೆ ಏಕೆಂದರೆ ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಗೋದಾಮಿನ ನೆಟ್‌ವರ್ಕ್‌ನಲ್ಲಿ ನಿಮಗೆ ನೈಜ-ಸಮಯದ ಗೋಚರತೆ ಇಲ್ಲ."
        }
      }
    },
    features: {
      title: 'ಎಂಟರ್‌ಪ್ರೈಸ್ ಪವರ್.',
      subtitle: 'ನಿಮಗಾಗಿ ಸರಳಗೊಳಿಸಲಾಗಿದೆ.',
      description: 'ಸೋಮಾ ಕೈಗಾರಿಕಾ-ದರ್ಜೆಯ ಲೆಕ್ಕಪತ್ರವನ್ನು ಆಧುನಿಕ ವ್ಯಾಪಾರ ಮಾಲೀಕರಿಗಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ತಡೆರಹಿತ ಇಂಟರ್ಫೇಸ್‌ನೊಂದಿಗೆ ಸಂಯೋಜಿಸುತ್ತದೆ.',
      cards: {
        invoicing: {
          title: 'GST ಇನ್ವಾಯ್ಸಿಂಗ್',
          description: 'ಸೆಕೆಂಡುಗಳಲ್ಲಿ GST-ಅನುಸರಣೆ ಇನ್ವಾಯ್ಸ್‌ಗಳನ್ನು ರಚಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ನಿಖರವಾದ ಸ್ಥಳೀಯ ಅನುಸರಣೆಯೊಂದಿಗೆ ತೆರಿಗೆ ದರಗಳನ್ನು ಸ್ವಯಂ-ಲೆಕ್ಕಾಚಾರ ಮಾಡಿ.'
        },
        inventory: {
          title: 'ಇನ್ವೆಂಟರಿ ಸಿಂಕ್',
          description: 'ಮಲ್ಟಿ-ಸಿಟಿ ಗೋದಾಮುಗಳಲ್ಲಿ ನೈಜ-ಸಮಯದ ಸ್ಟಾಕ್ ಮಟ್ಟಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ. ಇನ್ವೆಂಟರಿ ಆರೋಗ್ಯದ ಮೇಲೆ ಮುನ್ಸೂಚಕ ಎಚ್ಚರಿಕೆಗಳು.'
        },
        intelligence: {
          title: 'ಟ್ರೇಡ್ ಇಂಟೆಲಿಜೆನ್ಸ್',
          description: 'ನಮ್ಮ ಸ್ಥಳೀಯ ಆರ್ಕಿಟೆಕ್ಚರ್‌ನೊಂದಿಗೆ ಅತ್ಯಾಧುನಿಕ P&L, ನಗದು ಹರಿವು ಮತ್ತು ತೆರಿಗೆ ವರದಿಗಳನ್ನು ರಚಿಸಿ.'
        },
        mobile: {
          title: 'ಏಕೀಕೃತ ಮೊಬೈಲ್',
          description: 'ನಿಮ್ಮ ಫೋನ್‌ನಿಂದ ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಉದ್ಯಮವನ್ನು ನಿರ್ವಹಿಸಿ. ಎಂಟರ್‌ಪ್ರೈಸ್ ಪವರ್, ಗ್ರಾಹಕ ಸರಳತೆ.'
        }
      },
      learn_more: 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ'
    },
    cta: {
      badge: 'ಪ್ರೀ-ಲಾಂಚ್ ಪ್ರವೇಶ',
      title: 'ಭವಿಷ್ಯದ',
      subtitle: 'ಭಾರತೀಯ ವ್ಯಾಪಾರ.',
      description: "ಸೋಮಾದ ಎಂಟರ್‌ಪ್ರೈಸ್ ಆರ್ಕಿಟೆಕ್ಚರ್ ಅನ್ನು ಅನುಭವಿಸುವವರಲ್ಲಿ ಮೊದಲಿಗರಾಗಿರಿ. ವೇಗ, ಸ್ಕೇಲ್ ಮತ್ತು ಸ್ಥಳೀಯ ಅನುಸರಣೆಗಾಗಿ ನಿರ್ಮಿಸಲಾಗಿದೆ.",
      btn_waitlist: 'ವೈಟ್‌ಲಿಸ್ಟ್ ಸೇರಿ',
      btn_features: 'ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
      benefits: {
        early_access: 'ಆರಂಭಿಕ ಪ್ರವೇಶ',
        priority: 'ಆದ್ಯತೆ ಆನ್‌ಬೋರ್ಡಿಂಗ್',
        updates: 'ಅಪ್‌ಡೇಟ್‌ಗಳು ಸೇರಿವೆ'
      }
    },
    differentiation: {
      badge: 'ಓಮ್ನಿಚಾನೆಲ್ ಆರ್ಕಿಟೆಕ್ಚರ್',
      title: 'ಎಲ್ಲಿಂದಲಾದರೂ',
      subtitle: 'ವ್ಯಾಪಾರ ಮಾಡಿ.',
      description: 'ಗ್ರಾಹಕರೊಂದಿಗೆ ಮಾತನಾಡುವಾಗ ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ ಇನ್‌ವಾಯ್ಸ್ ಅನ್ನು ಪ್ರಾರಂಭಿಸಲು ಮತ್ತು ನಂತರ ನಿಮ್ಮ ಲ್ಯಾಪ್‌ಟಾಪ್‌ನಲ್ಲಿ ಪೂರ್ಣಗೊಳಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ಕಡಿಮೆ ಸಂಪರ್ಕವಿರುವ ಪ್ರದೇಶಗಳಲ್ಲಿಯೂ ಸಹ ಎಲ್ಲಾ ಸಾಧನಗಳಲ್ಲಿ ಡೇಟಾ ತಕ್ಷಣವೇ ಸಿಂಕ್ ಆಗುತ್ತದೆ.',
      items: {
        mobile: {
          title: 'ಮೊಬೈಲ್ ಫಸ್ಟ್',
          desc: 'ಭಾರತೀಯ ಮಾರುಕಟ್ಟೆಯಲ್ಲಿ ಹೈ-ಸ್ಪೀಡ್ ವ್ಯಾಪಾರಕ್ಕಾಗಿ ಸಿದ್ಧಪಡಿಸಲಾಗಿದೆ.'
        },
        desktop: {
          title: 'ಡೆಸ್ಕ್‌ಟಾಪ್ ಸ್ಕೇಲ್',
          desc: 'ಬೃಹತ್ ಇನ್ವೆಂಟರಿ ಕಾರ್ಯಾಚರಣೆಗಳು ಮತ್ತು ಬಲ್ಕ್ ಟ್ರೇಡ್ ಕ್ಲಿಯರಿಂಗ್.'
        },
        sync: {
          title: 'ಆಫ್‌ಲೈನ್ ಸಿಂಕ್',
          desc: 'ಡೇಟಾ ಸ್ಥಳೀಯವಾಗಿ ಉಳಿಯುತ್ತದೆ. ನೀವು ಕನೆಕ್ಟ್ ಆದ ತಕ್ಷಣ ಸಿಂಕ್ ಆಗುತ್ತದೆ.'
        }
      },
      stats: {
        latency: { value: '< 1s', label: 'ಟಾರ್ಗೆಟ್ ಲೇಟೆನ್ಸಿ' },
        uptime: { value: '99.9%', label: 'ಟಾರ್ಗೆಟ್ ಅಪ್‌ಟೈಮ್' },
        crypto: { value: 'AES-256', label: 'ಕ್ರಿಪ್ಟೋ' }
      },
      sync_status: 'ಲೈವ್ ಸಿಂಕ್'
    },
    faq: {
      badge: 'ಜ್ಞಾನ ಕೋಶ',
      title: 'ವಿವರಗಳನ್ನು',
      subtitle: 'ಸ್ಪಷ್ಟಪಡಿಸುವುದು.',
      questions: {
        setup: {
          q: 'ಲಾಂಚ್ ಆದ ನಂತರ ಸೋಮಾವನ್ನು ಸೆಟಪ್ ಮಾಡಲು ಎಷ್ಟು ಸಮಯ ಬೇಕಾಗುತ್ತದೆ?',
          a: 'ಸೋಮಾವನ್ನು 2 ನಿಮಿಷಗಳಲ್ಲಿ ಸಂಪೂರ್ಣವಾಗಿ ಸೆಟಪ್ ಮಾಡಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ನಿಮ್ಮ ವ್ಯಾಪಾರದ ಹೆಸರು ಮತ್ತು GST ಸಂಖ್ಯೆಯನ್ನು ಸೇರಿಸಿ, ಮತ್ತು ನೀವು ತಕ್ಷಣ ಇನ್‌ವಾಯ್ಸ್‌ಗಳನ್ನು ರಚಿಸಲು ಪ್ರಾರಂಭಿಸಬಹುದು. ಟ್ಯಾಲಿ, ಜೋಹೋ ಅಥವಾ ಸ್ಪ್ರೆಡ್‌ಶೀಟ್‌ಗಳಿಂದ ಉಚಿತ ಮೈಗ್ರೇಷನ್ ಸಹಾಯವನ್ನು ನೀಡಲು ನಾವು ಯೋಜಿಸುತ್ತಿದ್ದೇವೆ.'
        },
        security: {
          q: 'ನನ್ನ ವ್ಯಾಪಾರ ಡೇಟಾ ಸುರಕ್ಷಿತವೇ?',
          a: 'ಖಂಡಿತ. ನಾವು ಎಲ್ಲಾ ಡೇಟಾಗೆ ಬ್ಯಾಂಕ್-ಗ್ರೇಡ್ 256-ಬಿಟ್ ಎನ್‌ಕ್ರಿಪ್ಶನ್ ಅನ್ನು ಜಾರಿಗೊಳಿಸುತ್ತಿದ್ದೇವೆ. ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ಬಹು ಬ್ಯಾಕಪ್‌ಗಳೊಂದಿಗೆ ಭಾರತದ ಸುರಕ್ಷಿತ ಸರ್ವರ್‌ಗಳಲ್ಲಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ. ನಾವು ISO 27001 ಪ್ರಮಾಣೀಕೃತ ಮತ್ತು ಸಂಪೂರ್ಣವಾಗಿ DPDP ಕಂಪ್ಲೈಂಟ್ ಆಗಲು ನಿರ್ಮಿಸುತ್ತಿದ್ದೇವೆ.'
        },
        knowledge: {
          q: 'ನನಗೆ ಯಾವುದೇ ಅಕೌಂಟಿಂಗ್ ಅಥವಾ ತಾಂತ್ರಿಕ ಜ್ಞಾನ ಬೇಕೇ?',
          a: 'ಅಗತ್ಯವಿಲ್ಲ. ಸೋಮಾವನ್ನು ವ್ಯಾಪಾರ ಮಾಲೀಕರಿಗಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ, ಅಕೌಂಟೆಂಟ್‌ಗಳಿಗಲ್ಲ. ನೀವು ವಾಟ್ಸಾಪ್ ಬಳಸಬಹುದಾದರೆ, ನೀವು ಸೋಮಾವನ್ನು ಬಳಸಬಹುದು. ನಾವು ಎಲ್ಲಾ ಸಂಕೀರ್ಣ GST ಲೆಕ್ಕಾಚಾರಗಳು, ತೆರಿಗೆ ವರ್ಗೀಕರಣಗಳು ಮತ್ತು ಅನುಸರಣೆ ಅವಶ್ಯಕತೆಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ನಿರ್ವಹಿಸುತ್ತೇವೆ.'
        },
        offline: {
          q: 'ನನಗೆ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವಿಲ್ಲದಿದ್ದರೆ ಏನಾಗುತ್ತದೆ?',
          a: 'ಸೋಮಾ ಆಫ್‌ಲೈನ್‌ನಲ್ಲಿಯೂ ಕೆಲಸ ಮಾಡಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ನಮ್ಮ ಮೊಬೈಲ್ ಆಪ್‌ನಲ್ಲಿ ನೀವು ಇನ್‌ವಾಯ್ಸ್‌ಗಳನ್ನು ರಚಿಸುವುದು, ಇನ್ವೆಂಟರಿ ಅಪ್‌ಡೇಟ್ ಮಾಡುವುದು ಮತ್ತು ಮಾರಾಟವನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡುವುದನ್ನು ಮುಂದುವರಿಸಬಹುದು. ನೀವು ಆನ್‌ಲೈನ್‌ಗೆ ಬಂದ ತಕ್ಷಣ, ಎಲ್ಲವೂ ನಿಮ್ಮ ಎಲ್ಲಾ ಸಾಧನಗಳಲ್ಲಿ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಸಿಂಕ್ ಆಗುತ್ತದೆ.'
        },
        migration: {
          q: 'ಟ್ಯಾಲಿಯಿಂದ ನನ್ನ ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಡೇಟಾವನ್ನು ನಾನು ಮೈಗ್ರೇಟ್ ಮಾಡಬಹುದೇ?',
          a: 'ಹೌದು! ಟ್ಯಾಲಿ, ಜೋಹೋ ಬುಕ್ಸ್ ಅಥವಾ ಎಕ್ಸೆಲ್ ಸ್ಪ್ರೆಡ್‌ಶೀಟ್‌ಗಳಿಂದ ನಿಮ್ಮ ಗ್ರಾಹಕ ಡೇಟಾ, ಉತ್ಪನ್ನ ಕ್ಯಾಟಲಾಗ್ ಮತ್ತು ಐತಿಹಾಸಿಕ ವಹಿವಾಟುಗಳನ್ನು ಸರಳವಾಗಿ ನಿರ್ವಹಿಸಲು ನಾವು ಇಂಪೋರ್ಟ್ ಟೂಲ್ಸ್ ನಿರ್ಮಿಸುತ್ತಿದ್ದೇವೆ.'
        }
      },
      cta: {
        title: 'ಆರ್ಕಿಟೆಕ್ಚರಲ್ ಸಪೋರ್ಟ್',
        link: 'ನಮ್ಮ ಇಂಜಿನಿಯರ್‌ಗಳನ್ನು ಸಂಪರ್ಕಿಸಿ'
      }
    },
    testimonials: {
      badge: 'ನಮ್ಮ ಗಮನ',
      title: 'ಪ್ರತಿ ಭಾರತೀಯ ವ್ಯಾಪಾರಕ್ಕಾಗಿ',
      subtitle: 'ವಿನ್ಯಾಸ.',
      description: 'ಸಗಟು ವ್ಯಾಪಾರಿಗಳಿಂದ ತಯಾರಕರವರೆಗೆ, ನಿಮ್ಮ ಅನನ್ಯ ವ್ಯಾಪಾರ ಅವಶ್ಯಕತೆಗಳಿಗೆ ಹೊಂದಿಕೊಳ್ಳಲು ಸೋಮಾವನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗುತ್ತಿದೆ.',
      featured: {
        title: 'ಸಗಟು ಮತ್ತು ವಿತರಣೆ',
        description: 'ಬಲ್ಕ್ ಇನ್ವೆಂಟರಿ, ಸಂಕೀರ್ಣ ಬೆಲೆ ಶ್ರೇಣಿಗಳು ಮತ್ತು ಕ್ರೆಡಿಟ್ ಚಕ್ರಗಳನ್ನು ಸುಲಭವಾಗಿ ನಿರ್ವಹಿಸಿ. ಸೋಮಾ ವಾಲ್ಯೂಮ್ ಅನ್ನು ನಿರ್ವಹಿಸಲು ನಿರ್ಮಿಸಲಾಗಿದೆ ಆದ್ದರಿಂದ ನೀವು ವ್ಯಾಪಾರದ ಮೇಲೆ ಗಮನಹರಿಸಬಹುದು.',
        badge: {
          title: 'ಸಗಟು',
          desc: 'ಹೆಚ್ಚಿನ ವಾಲ್ಯೂಮ್ • ಕಡಿಮೆ ಮಾರ್ಜಿನ್'
        },
        stats: {
          inventory: { label: 'ಇನ್ವೆಂಟರಿ', value: 'ಬ್ಯಾಚ್ ಟ್ರ್ಯಾಕಿಂಗ್' },
          pricing: { label: 'ಬೆಲೆ', value: 'ಮಲ್ಟಿ-ಟೈರ್' },
          finance: { label: 'ಹಣಕಾಸು', value: 'ಕ್ರೆಡಿಟ್ ನಿರ್ವಹಣೆ' }
        }
      },
      industries: {
        manufacturing: {
          title: 'ತಯಾರಿಕೆ',
          description: 'ಕಚ್ಚಾ ವಸ್ತುಗಳು, ಬಿಲ್ ಆಫ್ ಮೆಟೀರಿಯಲ್ಸ್ (BOM) ಮತ್ತು ಉತ್ಪಾದನಾ ವೆಚ್ಚಗಳ ನಿಖರವಾದ ಟ್ರ್ಯಾಕಿಂಗ್ ಅನ್ನು ಗುರಿಯಾಗಿಸಿಕೊಂಡಿದೆ.'
        },
        retail: {
          title: 'ಚಿಲ್ಲರೆ ಸರಣಿಗಳು',
          description: 'ಯೋಜಿತ ಏಕೀಕೃತ ಪಾಯಿಂಟ್ ಆಫ್ ಸೇಲ್ (POS), ಬಾರ್‌ಕೋಡ್ ಸ್ಕ್ಯಾನಿಂಗ್ ಮತ್ತು ರಿಯಲ್-ಟೈಮ್ ಮಲ್ಟಿ-ಸ್ಟೋರ್ ಸಿಂಕ್ರೊನೈಸೇಶನ್.'
        },
        service: {
          title: 'ಸೇವಾ ಪೂರೈಕೆದಾರರು',
          description: 'ಪ್ರಾಜೆಕ್ಟ್-ಆಧಾರಿತ ಬಿಲ್ಲಿಂಗ್, ಸಮಯ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಸ್ವಯಂಚಾಲಿತ ವೆಚ್ಚ ನಿರ್ವಹಣೆಗಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.'
        }
      }
    },
    features_page: {
      badge: 'SME OS ಕೋರ್ ಫೀಚರ್‌ಗಳು',
      title: 'ಇದಕ್ಕಾಗಿ',
      subtitle: 'ನಿರ್ಮಿಸಲಾಗಿದೆ ನಿಲ್ಲಿಸಲಾಗದ SME.',
      description: 'ಆಧುನಿಕ SME ಗಳ ಸಂಕೀರ್ಣತೆಗಳನ್ನು ಪರಿಹರಿಸಲು ಸೋಮಾವನ್ನು ನೆಲದಿಂದ ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ. GST ಯನ್ನು ಸ್ವಯಂಚಾಲಿತಗೊಳಿಸಿ, ದಾಸ್ತಾನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ಒಂದೇ ವೇದಿಕೆಯಲ್ಲಿ ನೈಜ-ಸಮಯದ ಒಳನೋಟಗಳನ್ನು ಪಡೆಯಿರಿ.',
      cta_waitlist: 'ವೇಟ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿ',
      cta_learn_more: 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ',
      engineered_workflows: 'ಇಂಜಿನಿಯರ್ಡ್ ವರ್ಕ್‌ಫ್ಲೋಗಳು',
      testimonial: {
        quote: '"ಅಂತಿಮವಾಗಿ, ಭಾರತೀಯ ವ್ಯಾಪಾರದ ಸಂಕೀರ್ಣತೆಯನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳುವ ವ್ಯಾಪಾರ OS. ನಮ್ಮ ಕಾರ್ಯಾಚರಣೆಗಳನ್ನು ಸೋಮಾಗೆ ವರ್ಗಾಯಿಸಲು ನಾವು ಕುತೂಹಲದಿಂದ ಕಾಯುತ್ತಿದ್ದೇವೆ."',
        author: 'ಅಂಕಿತ್ ವಾರ್ಷ್ನಿ',
        role: 'ಸಿಇಒ, ವಾರ್ಷ್ನಿ ಟೆಕ್ಸ್‌ಟೈಲ್ಸ್ (ಬೀಟಾ ಪಾಲುದಾರ)'
      },
      final_cta: {
        title: 'ಭವಿಷ್ಯವನ್ನು ಅನುಭವಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?',
        description: 'ಭಾರತೀಯ SME ಕಾರ್ಯಾಚರಣೆಗಳನ್ನು ಮರುವ್ಯಾಖ್ಯಾನಿಸುವ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಅನ್ನು ಪ್ರವೇಶಿಸುವ ಮೊದಲ ವ್ಯಕ್ತಿಗಳಲ್ಲಿ ಒಬ್ಬರಾಗಿ. ಇಂದು ಆರಂಭಿಕ ಪ್ರವೇಶವನ್ನು ವಿನಂತಿಸಿ.',
        request_access: 'ಪ್ರವೇಶವನ್ನು ವಿನಂತಿಸಿ',
        view_plans: 'ಯೋಜನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
        footer: 'ಲೋಕಲ್-ಫಸ್ಟ್ • GST ಕಂಪ್ಲೈಂಟ್ • ಎಂಟರ್‌ಪ್ರೈಸ್ ಸ್ಕೇಲ್'
      },
      features: {
        gst: {
          title: 'GST ಅನುಸರಣೆ',
          description: 'ಭಾರತೀಯ ತೆರಿಗೆ ಪರಿಸರ ವ್ಯವಸ್ಥೆಗಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಸ್ವಯಂಚಾಲಿತ GST ಫೈಲಿಂಗ್, ಇನ್‌ವಾಯ್ಸ್ ರಚನೆ ಮತ್ತು ಅನುಸರಣೆ ಟ್ರ್ಯಾಕಿಂಗ್.',
          benefits: {
            filing: 'ಸ್ವಯಂಚಾಲಿತ GSTR ಫೈಲಿಂಗ್',
            alerts: 'ರಿಯಲ್-ಟೈಮ್ ಅನುಸರಣೆ ಎಚ್ಚರಿಕೆಗಳು',
            validation: 'ಇನ್‌ವಾಯ್ಸ್ ಮೌಲ್ಯೀಕರಣ'
          }
        },
        inventory: {
          title: 'ಇನ್ವೆಂಟರಿ ಸಿಂಕ್',
          description: 'ಸ್ಮಾರ್ಟ್ ಮರುಕ್ರಮಗೊಳಿಸುವ ಪಾಯಿಂಟ್‌ಗಳು ಮತ್ತು ಅನಾಲಿಟಿಕ್ಸ್‌ನೊಂದಿಗೆ ಬಹು ಸ್ಥಳಗಳಲ್ಲಿ ನೈಜ-ಸಮಯದ ದಾಸ್ತಾನು ಟ್ರ್ಯಾಕಿಂಗ್.',
          benefits: {
            tracking: 'ಮಲ್ಟಿ-ಲೊಕೇಶನ್ ಟ್ರ್ಯಾಕಿಂಗ್',
            alerts: 'ಸ್ವಯಂಚಾಲಿತ ಮರುಕ್ರಮಗೊಳಿಸುವ ಎಚ್ಚರಿಕೆಗಳು',
            analytics: 'ಸ್ಟಾಕ್ ಚಲನೆಯ ಅನಾಲಿಟಿಕ್ಸ್'
          }
        },
        analytics: {
          title: 'ಸ್ಮಾರ್ಟ್ ಅನಾಲಿಟಿಕ್ಸ್',
          description: 'ಸ್ವಯಂಚಾಲಿತ P&L ಮತ್ತು ನಗದು ಹರಿವಿನ ವರದಿಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವ್ಯಾಪಾರ ಕಾರ್ಯಕ್ಷಮತೆಯ ಬಗ್ಗೆ ಆಳವಾದ ಒಳನೋಟಗಳನ್ನು ಪಡೆಯಿರಿ.',
          benefits: {
            pl: 'P&L ಹೇಳಿಕೆಗಳು',
            cashflow: 'ನಗದು ಹರಿವಿನ ವಿಶ್ಲೇಷಣೆ',
            tax: 'ತೆರಿಗೆ ಆಪ್ಟಿಮೈಸೇಶನ್ ಒಳನೋಟಗಳು'
          }
        },
        crm: {
          title: 'ಗ್ರಾಹಕ CRM',
          description: 'ಇತಿಹಾಸ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಸ್ಮಾರ್ಟ್ ಎಂಗೇಜ್‌ಮೆಂಟ್ ಮೂಲಕ ನಿಮ್ಮ ಗ್ರಾಹಕರೊಂದಿಗೆ ಶಾಶ್ವತ ಸಂಬಂಧಗಳನ್ನು ಬೆಳೆಸಿಕೊಳ್ಳಿ.',
          benefits: {
            profiles: 'ಗ್ರಾಹಕ ಪ್ರೊಫೈಲ್‌ಗಳು',
            history: 'ಆರ್ಡರ್ ಇತಿಹಾಸ',
            logs: 'ಸಂವಹನ ಲಾಗ್‌ಗಳು'
          }
        },
        global: {
          title: 'ಜಾಗತಿಕ ವಾಣಿಜ್ಯ',
          description: 'ಮಲ್ಟಿ-ಕರೆನ್ಸಿ ಬೆಂಬಲ ಮತ್ತು FEMA-ಕಂಪ್ಲೈಂಟ್ ಇನ್‌ವಾಯ್ಸಿಂಗ್ ವರ್ಕ್‌ಫ್ಲೋಗಳೊಂದಿಗೆ ಜಾಗತಿಕವಾಗಿ ವಿಸ್ತರಿಸಿ.',
          benefits: {
            rates: 'ರಿಯಲ್-ಟೈಮ್ ವಿನಿಮಯ ದರಗಳು',
            invoicing: 'ಮಲ್ಟಿ-ಕರೆನ್ಸಿ ಇನ್‌ವಾಯ್ಸಿಂಗ್',
            compliance: 'FEMA ಅನುಸರಣೆ'
          }
        },
        security: {
          title: 'ಬ್ಯಾಂಕ್-ಗ್ರೇಡ್ ಭದ್ರತೆ',
          description: 'ನಿಮ್ಮ ವ್ಯಾಪಾರ ಡೇಟಾವನ್ನು ಅತ್ಯುನ್ನತ ಎನ್‌ಕ್ರಿಪ್ಶನ್ ಮಾನದಂಡಗಳು ಮತ್ತು ಸ್ಥಳೀಯ ಅನುಸರಣೆಯಿಂದ ರಕ್ಷಿಸಲಾಗಿದೆ.',
          benefits: {
            encryption: 'ಎಂಡ್-ಟು-ಎಂಡ್ ಎನ್‌ಕ್ರಿಪ್ಶನ್',
            backups: 'ನಿಯಮಿತ ಬ್ಯಾಕಪ್‌ಗಳು',
            compliance: 'ಭಾರತೀಯ DPDP ಅನುಸರಣೆ'
          }
        }
      }
    },
    pricing_page: {
      badge: 'ಪಾರದರ್ಶಕ ಬೆಲೆ',
      title: 'ಸರಳ, ಪಾರದರ್ಶಕ ಬೆಲೆ',
      subtitle: 'ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ.',
      description: '14-ದಿನದ ಉಚಿತ ಪ್ರಯೋಗದೊಂದಿಗೆ ಪ್ರಾರಂಭಿಸಿ. ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಅಗತ್ಯವಿಲ್ಲ.',
      billing: {
        monthly: 'ಮಾಸಿಕ',
        yearly: 'ವಾರ್ಷಿಕ',
        save: '20% ಉಳಿಸಿ'
      },
      per_month: '/ತಿಂಗಳಿಗೆ',
      yearly_discount: 'ವಾರ್ಷಿಕ ರಿಯಾಯಿತಿ',
      plans: {
        features_title: 'ಒಳಗೊಂಡಿರುವ ವೈಶಿಷ್ಟ್ಯಗಳು',
        per_month: '/ತಿಂಗಳು',
        recommended: 'ಸ್ಕೇಲ್‌ಗಾಗಿ ಶಿಫಾರಸು ಮಾಡಲಾಗಿದೆ',
        starter: {
          name: 'ಸ್ಟಾರ್ಟರ್',
          description: 'ಸಣ್ಣ ವ್ಯಾಪಾರಗಳು ಮತ್ತು ಬೆಳೆಯುತ್ತಿರುವ ಸ್ಟಾರ್ಟಪ್‌ಗಳಿಗೆ ಸೂಕ್ತವಾಗಿದೆ',
          cta: 'ವೇಟ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿ',
          features: {
            invoices: 'ತಿಂಗಳಿಗೆ 100 ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
            gst: 'ಮೂಲ GST ಅನುಸರಣೆ',
            inventory: 'ಏಕ ಸ್ಥಳ ದಾಸ್ತಾನು',
            support: 'ಇಮೇಲ್ ಬೆಂಬಲ',
            reporting: 'ಮೂಲ ವರದಿ',
            mobile: 'ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್ ಪ್ರವೇಶ'
          }
        },
        professional: {
          name: 'ವೃತ್ತಿಪರ',
          description: 'ಸಂಕೀರ್ಣ ಅಗತ್ಯಗಳಿರುವ ಬೆಳೆಯುತ್ತಿರುವ ವ್ಯಾಪಾರಗಳಿಗೆ ಆದರ್ಶ',
          cta: 'ವೇಟ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿ',
          features: {
            invoices: 'ಅನಿಯಮಿತ ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
            gst: 'ಸುಧಾರಿತ GST ಅನುಸರಣೆ',
            inventory: 'ಮಲ್ಟಿ-ಲೊಕೇಶನ್ ದಾಸ್ತಾನು',
            support: 'ಆದ್ಯತೆಯ ಬೆಂಬಲ',
            analytics: 'ಸುಧಾರಿತ ಅನಾಲಿಟಿಕ್ಸ್',
            api: 'API ಪ್ರವೇಶ',
            integrations: 'ಕಸ್ಟಮ್ ಇಂಟಿಗ್ರೇಷನ್‌ಗಳು',
            users: 'ಮಲ್ಟಿ-ಯೂಸರ್ ಪ್ರವೇಶ'
          }
        },
        enterprise: {
          name: 'ಎಂಟರ್‌ಪ್ರೈಸ್',
          description: 'ತಂಡದ ವರ್ಕ್‌ಫ್ಲೋಗಳಿರುವ ದೊಡ್ಡ ಪ್ರಮಾಣದ ವ್ಯಾಪಾರಗಳಿಗೆ',
          cta: 'ಆರಂಭಿಕ ಪ್ರವೇಶಕ್ಕಾಗಿ ಸಂಪರ್ಕಿಸಿ',
          features: {
            all_pro: 'ವೃತ್ತಿಪರದಲ್ಲಿ ಎಲ್ಲವೂ',
            manager: 'ಮೀಸಲಾದ ಖಾತೆ ನಿರ್ವಾಹಕ',
            workflows: 'ಕಸ್ಟಮ್ ವರ್ಕ್‌ಫ್ಲೋಗಳು',
            security: 'ಸುಧಾರಿತ ಭದ್ರತಾ ವೈಶಿಷ್ಟ್ಯಗಳು',
            whitelabel: 'ವೈಟ್-ಲೇಬಲ್ ಆಯ್ಕೆಗಳು',
            access: 'ಪಾತ್ರ-ಆಧಾರಿತ ಪ್ರವೇಶ',
            reporting: 'ಕಸ್ಟಮ್ ವರದಿ',
            deployment: 'ಆನ್-ಪ್ರಿಮೈಸ್ ನಿಯೋಜನೆ'
          }
        }
      },
      faq: {
        badge: 'FAQ',
        title: 'ಪ್ರಶ್ನೆಗಳು',
        subtitle: 'ಬಿಲ್ಲಿಂಗ್ ಮತ್ತು ಬೆಲೆ ಬಗ್ಗೆ ನೀವು ತಿಳಿದುಕೊಳ್ಳಬೇಕಾದ ಎಲ್ಲವೂ.',
        questions: {
          trial: {
            q: 'ಉಚಿತ ಪ್ರಯೋಗ ಇರುತ್ತದೆಯೇ?',
            a: 'ಹೌದು! ಪ್ರಾರಂಭಿಸಿದ ನಂತರ, ಎಲ್ಲಾ ಯೋಜನೆಗಳು 14-ದಿನದ ಉಚಿತ ಪ್ರಯೋಗದೊಂದಿಗೆ ಬರುತ್ತವೆ. ನೀವು ಎಲ್ಲಾ ವೈಶಿಷ್ಟ್ಯಗಳಿಗೆ ಸಂಪೂರ್ಣ ಪ್ರವೇಶವನ್ನು ಪಡೆಯುತ್ತೀರಿ ಇದರಿಂದ ಸೋಮಾ ನಿಮ್ಮ ವ್ಯಾಪಾರಕ್ಕೆ ತರುವ ಮೌಲ್ಯವನ್ನು ನೀವು ನೋಡಬಹುದು. ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಅಗತ್ಯವಿರುವುದಿಲ್ಲ.'
          },
          change: {
            q: 'ನಾನು ಯಾವಾಗ ಬೇಕಾದರೂ ಯೋಜನೆಗಳನ್ನು ಬದಲಾಯಿಸಬಹುದೇ?',
            a: 'ಖಂಡಿತ. ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಯೋಜನೆಯನ್ನು ಅಪ್‌ಗ್ರೇಡ್ ಅಥವಾ ಡೌನ್‌ಗ್ರೇಡ್ ಮಾಡಬಹುದು. ನೀವು ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿದಾಗ, ಹೊಸ ವೈಶಿಷ್ಟ್ಯಗಳು ತಕ್ಷಣವೇ ಲಭ್ಯವಿರುತ್ತವೆ.'
          },
          payment: {
            q: 'ಯಾವ ಪಾವತಿ ವಿಧಾನಗಳನ್ನು ಸ್ವೀಕರಿಸಲಾಗುತ್ತದೆ?',
            a: 'ನಾವು ಎಲ್ಲಾ ಪ್ರಮುಖ ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್‌ಗಳು, ಡೆಬಿಟ್ ಕಾರ್ಡ್‌ಗಳು, UPI, ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್ ಮತ್ತು PhonePe, Paytm ಮತ್ತು Google Pay ಸೇರಿದಂತೆ ಭಾರತದಲ್ಲಿ ಜನಪ್ರಿಯ ಡಿಜಿಟಲ್ ವಾಲೆಟ್‌ಗಳನ್ನು ಸ್ವೀಕರಿಸಲು ಯೋಜಿಸುತ್ತಿದ್ದೇವೆ.'
          },
          security: {
            q: 'ನನ್ನ ಡೇಟಾ ಸುರಕ್ಷಿತವೇ?',
            a: 'ಹೌದು, ನಾವು ಎಂಟರ್‌ಪ್ರೈಸ್-ಗ್ರೇಡ್ 256-ಬಿಟ್ SSL ಎನ್‌ಕ್ರಿಪ್ಶನ್ ಅನ್ನು ಬಳಸುತ್ತೇವೆ. ನಿಮ್ಮ ವ್ಯಾಪಾರ ಡೇಟಾ ಸುರಕ್ಷಿತವಾಗಿದೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ನಾವು SOC2 ಕಂಪ್ಲೈಂಟ್ ಮತ್ತು ಎಲ್ಲಾ ಭಾರತೀಯ ಡೇಟಾ ಸಂರಕ್ಷಣಾ ನಿಯಮಗಳನ್ನು (DPDP) ಅನುಸರಿಸುತ್ತಿದ್ದೇವೆ.'
          }
        }
      },
      final_cta: {
        title: 'ಸಿದ್ಧರಿದ್ದೀರಾ',
        subtitle: 'ಗಂಭೀರ ಸ್ಕೇಲ್‌ಗಾಗಿ?',
        book_call: 'ಆರ್ಕಿಟೆಕ್ಚರ್ ಕರೆ ಬುಕ್ ಮಾಡಿ',
        contact_sales: 'ಮಾರಾಟವನ್ನು ಸಂಪರ್ಕಿಸಿ',
        footer: 'ಸೋಮಾವನ್ನು ನಿಯೋಜಿಸಿ. ಪರಂಪರೆಯನ್ನು ನಿರ್ಮಿಸಿ.'
      }
    },
    solutions_page: {
      badge: 'ಉದ್ಯಮ ನಿರ್ದಿಷ್ಟ DNA',
      title: 'ಕಸ್ಟಮ್ ಮೇಡ್',
      subtitle: 'ನಿಮ್ಮ ಸ್ಕೇಲ್‌ಗಾಗಿ.',
      description: 'ಜೆನೆರಿಕ್ ಸಾಫ್ಟ್‌ವೇರ್ ವಿಫಲಗೊಳ್ಳುತ್ತದೆ ಏಕೆಂದರೆ ನಿಮ್ಮ ವ್ಯಾಪಾರ ಅನನ್ಯವಾಗಿದೆ. ಸೋಮಾ ನಿಮ್ಮ ಉದ್ಯಮ ನಿರ್ದಿಷ್ಟ ವರ್ಕ್‌ಫ್ಲೋಗಳಿಗಾಗಿ ಬಾಕ್ಸ್‌ನಿಂದ ಹೊರಗೆ ಆಪ್ಟಿಮೈಸ್ ಆಗುತ್ತದೆ.',
      cta_contact: 'ಮಾರಾಟವನ್ನು ಸಂಪರ್ಕಿಸಿ',
      cta_case_studies: 'ಕೇಸ್ ಸ್ಟಡೀಸ್ ವೀಕ್ಷಿಸಿ',
      core_workflow: 'ಕೋರ್ ವರ್ಕ್‌ಫ್ಲೋ ಘಟಕಗಳು',
      top_users: 'ಉನ್ನತ ಉದ್ಯಮ ಬಳಕೆದಾರರು',
      validated_results: 'ದೃಢೀಕರಿಸಿದ ಫಲಿತಾಂಶಗಳು',
      deployment: 'ಎಂಟರ್‌ಪ್ರೈಸ್ ನಿಯೋಜನೆ',
      built_for_scale: 'ಸಂಕೀರ್ಣ ಭಾರತೀಯ ಸ್ಕೇಲ್‌ಗಾಗಿ ನಿರ್ಮಿಸಲಾಗಿದೆ.',
      industries: {
        retail: {
          title: 'Retail & E-commerce',
          description: 'ಏಕೀಕೃತ ದಾಸ್ತಾನು ಮತ್ತು ಮಲ್ಟಿ-ಚಾನೆಲ್ ಬಿಲ್ಲಿಂಗ್‌ನೊಂದಿಗೆ ನಿಮ್ಮ ಚಿಲ್ಲರೆ ವ್ಯಾಪಾರವನ್ನು ಅಳೆಯಿರಿ.',
          features: {
            inventory: 'ಮಲ್ಟಿ-ಚಾನೆಲ್ ದಾಸ್ತಾನು ಸಿಂಕ್',
            pos: 'ಪಾಯಿಂಟ್ ಆಫ್ ಸೇಲ್ (POS) ಏಕೀಕರಣ',
            loyalty: 'ಲಾಯಲ್ಟಿ ಮತ್ತು ಉಡುಗೊರೆ ಕಾರ್ಡ್‌ಗಳು',
            reordering: 'ಸ್ವಯಂಚಾಲಿತ ಸ್ಟಾಕ್ ಮರುಕ್ರಮಗೊಳಿಸುವಿಕೆ'
          },
          tags: {
            fashion: 'ಫ್ಯಾಷನ್',
            electronics: 'ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್',
            chains: 'ರೀಟೇಲ್ ಚೈನ್ಸ್'
          },
          proof: {
            label: 'ಸ್ಟಾಕ್‌ಔಟ್ ಕಡಿತ',
            company: 'ಫ್ಯಾಷನ್ ರೀಟೇಲ್'
          }
        },
        manufacturing: {
          title: 'Manufacturing',
          description: 'ಸ್ಮಾರ್ಟ್ ವೆಚ್ಚ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಕಚ್ಚಾ ವಸ್ತುಗಳ ವರ್ಕ್‌ಫ್ಲೋಗಳೊಂದಿಗೆ ಉತ್ಪಾದನೆಯನ್ನು ಆಪ್ಟಿಮೈಸ್ ಮಾಡಿ.',
          features: {
            planning: 'ಉತ್ಪಾದನಾ ಯೋಜನೆ (MRP)',
            bom: 'BOM ನಿರ್ವಹಣೆ',
            waste: 'ತ್ಯಾಜ್ಯ ಮತ್ತು ಸ್ಕ್ರ್ಯಾಪೇಜ್ ಟ್ರ್ಯಾಕಿಂಗ್',
            labor: 'ಕಾರ್ಮಿಕ ವೆಚ್ಚ ಗುಣಲಕ್ಷಣ'
          },
          tags: {
            auto: 'ಆಟೋ ಪಾರ್ಟ್ಸ್',
            textile: 'ಟೆಕ್ಸ್ಟೈಲ್ ಮಿಲ್ಸ್',
            food: 'ಫುಡ್ ಟೆಕ್'
          },
          proof: {
            label: 'ತ್ಯಾಜ್ಯ ಕಡಿತ',
            company: 'ತಯಾರಿಕೆ'
          }
        },
        services: {
          title: 'Services & Agencies',
          description: 'ಶೂನ್ಯ ಪ್ರಯತ್ನದೊಂದಿಗೆ ಕ್ಲೈಂಟ್ ಬಿಲ್ಲಿಂಗ್ ಮತ್ತು ಪ್ರಾಜೆಕ್ಟ್ ಲಾಭದಾಯಕತೆಯನ್ನು ಸುಗಮಗೊಳಿಸಿ.',
          features: {
            accounting: 'ಪ್ರಾಜೆಕ್ಟ್-ಆಧಾರಿತ ಲೆಕ್ಕಪತ್ರ',
            portal: 'ಪಾವತಿಗಾಗಿ ಕ್ಲೈಂಟ್ ಪೋರ್ಟಲ್',
            tracking: 'ಇನ್‌ವಾಯ್ಸ್‌ಗಾಗಿ ಸಮಯ ಟ್ರ್ಯಾಕಿಂಗ್',
            billing: 'ಮರುಕಳಿಸುವ ಸೇವಾ ಬಿಲ್ಲಿಂಗ್'
          },
          tags: {
            it: 'IT ಏಜೆನ್ಸಿಗಳು',
            law: 'ಕಾನೂನು ಸಂಸ್ಥೆಗಳು',
            consulting: 'ಕನ್ಸಲ್ಟಿಂಗ್'
          },
          proof: {
            label: 'ವೇಗದ ಬಿಲ್ಲಿಂಗ್',
            company: 'ಸೇವಾ ಏಜೆನ್ಸಿ'
          }
        },
        healthcare: {
          title: 'Healthcare',
          description: 'ವೈದ್ಯಕೀಯ ಅಭ್ಯಾಸಗಳು ಮತ್ತು ಲ್ಯಾಬ್‌ಗಳಿಗಾಗಿ ಅನುಸರಣೆ-ಸಿದ್ಧ ಬ್ಯಾಕ್-ಆಫೀಸ್ ಪರಿಕರಗಳು.',
          features: {
            inventory: 'ವೈದ್ಯಕೀಯ ದಾಸ್ತಾನು ನಿಯಂತ್ರಣ',
            claims: 'ವಿಮೆ ಕ್ಲೈಮ್ ಟ್ರ್ಯಾಕಿಂಗ್',
            billing: 'ರೋಗಿಯ ಬಿಲ್ಲಿಂಗ್ ಆಟೊಮೇಷನ್',
            reporting: 'ನಿಯಂತ್ರಕ ವರದಿ'
          },
          tags: {
            clinics: 'ಕ್ಲಿನಿಕ್‌ಗಳು',
            pharmacies: 'ಫಾರ್ಮಸಿಗಳು',
            labs: 'ಲ್ಯಾಬ್‌ಗಳು'
          },
          proof: {
            label: 'ಬಿಲ್ಲಿಂಗ್ ನಿಖರತೆ',
            company: 'ಆರೋಗ್ಯ ಸೇವೆ'
          }
        }
      }
    },
    cta_section: {
      title_prefix: 'ನಿಮ್ಮ ಪರಿಹಾರ DNA',
      title_suffix: 'ಹುಡುಕಲು ಸಿದ್ಧರಿದ್ದೀರಾ?',
      book_audit: 'ಆರ್ಕಿಟೆಕ್ಚರ್ ಆಡಿಟ್ ಬುಕ್ ಮಾಡಿ',
      talk_expert: 'ತಜ್ಞರೊಂದಿಗೆ ಮಾತನಾಡಿ',
      footer_text: 'ಸ್ಥಳೀಯವಾಗಿ ನಿಯೋಜಿಸಿ. ಜಾಗತಿಕವಾಗಿ ಸ್ಕೇಲ್ ಮಾಡಿ.'
    },
    resources_page: {
      badge: 'ಸೋಮಾ ನಾಲೆಡ್ಜ್ ಹಬ್',
      title_prefix: 'ಕಲಿಯಿರಿ',
      title_suffix: 'ಬೆಳೆಯಿರಿ',
      description: 'ಅಜೇಯ ಭಾರತೀಯ SME ಅನ್ನು ನಿರ್ಮಿಸಲು ನಿಮಗೆ ಸಹಾಯ ಮಾಡುವ ವಿಶೇಷ ಮಾರ್ಗದರ್ಶಿಗಳು, ಉದ್ಯಮ ಒಳನೋಟಗಳು ಮತ್ತು ತಾಂತ್ರಿಕ ದಾಖಲಾತಿಗಳು.',
      ledger: {
        title: 'ದ ಲೆಡ್ಜರ್',
        subtitle: 'SME ಸ್ಕೇಲ್ ಮತ್ತು ಲೋಕಲ್-ಫಸ್ಟ್ ಆರ್ಕಿಟೆಕ್ಚರ್ ಕುರಿತು ಪತ್ರಿಕೆ.',
        cta: 'ಸಂಗ್ರಹವನ್ನು ಅನ್ವೇಷಿಸಿ'
      },
      implementation: {
        title_prefix: 'ಅನುಷ್ಠಾನ',
        title_suffix: 'ಪಾಂಡಿತ್ಯ',
        description: 'ನಮ್ಮ ಆರ್ಕಿಟೆಕ್ಟ್‌ಗಳು ದೊಡ್ಡ ಪ್ರಮಾಣದ ಎಂಟರ್‌ಪ್ರೈಸ್ ನಿಯೋಜನೆಗಳು ಮತ್ತು ಕಸ್ಟಮ್ ಬಿಲ್ಡ್ ವರ್ಕ್‌ಫ್ಲೋಗಳಿಗಾಗಿ ಮೀಸಲಾದ ಸೆಷನ್‌ಗಳನ್ನು ಒದಗಿಸುತ್ತಾರೆ.',
        cta_training: 'ತರಬೇತಿ ನಿಗದಿಪಡಿಸಿ',
        cta_support: 'ತಾಂತ್ರಿಕ ಬೆಂಬಲ',
        footer: 'ಆರ್ಕಿಟೆಕ್ಚರ್ • ಇಂಟಿಗ್ರೇಷನ್ • ಸ್ಕೇಲ್'
      },
      cards: {
        quick_start: {
          title: "ತ್ವರಿತ ಪ್ರಾರಂಭ ಮಾರ್ಗದರ್ಶಿ",
          description: "10 ನಿಮಿಷಗಳಲ್ಲಿ ಸೋಮಾದೊಂದಿಗೆ ನಿಮ್ಮ ಪ್ರಯಾಣವನ್ನು ಪ್ರಾರಂಭಿಸಲು ನಿಮಗೆ ಬೇಕಾದ ಎಲ್ಲವೂ.",
          tag: "ಅಗತ್ಯ"
        },
        mastering_gst: {
          title: "GST ಪಾಂಡಿತ್ಯ",
          description: "GSTR ಆಟೊಮೇಷನ್, ಇ-ವೇ ಬಿಲ್‌ಗಳು ಮತ್ತು ಸ್ಥಳೀಯ ತೆರಿಗೆ ಅನುಸರಣೆಗೆ ಆಳವಾದ ಡೈವ್.",
          tag: "ಅಪ್‌ಡೇಟ್ 2026"
        },
        inventory_strategy: {
          title: "ಇನ್ವೆಂಟರಿ ತಂತ್ರ",
          description: "V.K. ಪ್ರಿಂಟ್ಸ್ ಸೋಮಾದ ಮಲ್ಟಿ-ಲೊಕೇಶನ್ ಸಿಂಕ್ ಬಳಸಿ 400% ಬೆಳವಣಿಗೆಯನ್ನು ಹೇಗೆ ನಿರ್ವಹಿಸಿತು.",
          tag: "ಕೇಸ್ ಸ್ಟಡಿ"
        },
        api_docs: {
          title: "API ದಾಖಲಾತಿ",
          description: "ಕಸ್ಟಮ್ ಇಂಟಿಗ್ರೇಷನ್‌ಗಳನ್ನು ನಿರ್ಮಿಸಿ ಮತ್ತು ಸೋಮಾದ ಸಾಮರ್ಥ್ಯಗಳನ್ನು ವಿಸ್ತರಿಸಿ.",
          tag: "ತಾಂತ್ರಿಕ"
        },
        community: {
          title: "ಸಮುದಾಯ ವೇದಿಕೆ",
          description: "ಇತರ ವ್ಯಾಪಾರ ಮಾಲೀಕರು ಮತ್ತು ಸೋಮಾ ತಜ್ಞರೊಂದಿಗೆ ಸಂಪರ್ಕ ಸಾಧಿಸಿ.",
          tag: "ಬಾಹ್ಯ"
        },
        webinar: {
          title: "ವೆಬಿನಾರ್: GST 2026",
          description: "ಹೊಸ ತೆರಿಗೆ ನಿಯಮಗಳ ಕುರಿತು ನಮ್ಮ ಇತ್ತೀಚಿನ ಸೆಷನ್‌ನ ರೆಕಾರ್ಡಿಂಗ್ ವೀಕ್ಷಿಸಿ.",
          tag: "ಹೊಸ"
        }
      }
    },
  },
  // Layout translations
  layout: {
    navbar: {
      login: 'ಲಾಗಿನ್',
      get_started: 'ಪ್ರಾರಂಭಿಸಿ',
      dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
      links: {
        features: 'ವೈಶಿಷ್ಟ್ಯಗಳು',
        pricing: 'ಬೆಲೆಗಳು',
        solutions: 'ಪರಿಹಾರಗಳು',
        resources: 'ಸಂಪನ್ಮೂಲಗಳು'
      }
    },
    footer: {
      brand_desc: 'ಭಾರತೀಯ ಉದ್ಯಮಗಳ ಸ್ಕೇಲ್‌ಗಾಗಿ ಎಂಜಿನಿಯರಿಂಗ್ ಮಾಡಲಾದ ಪ್ರೀಮಿಯಂ ಬಿಸಿನೆಸ್ ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್.',
      engineered_for: 'ಇಂಜಿನಿಯರ್ಡ್ ಫಾರ್',
      excellence: 'ಎಕ್ಸಲೆನ್ಸ್',
      sections: {
        product: 'ಉತ್ಪನ್ನ',
        company: 'ಕಂಪನಿ',
        resources: 'ಸಂಪನ್ಮೂಲಗಳು',
        legal: 'ಕಾನೂನು'
      },
      links: {
        features: 'ವೈಶಿಷ್ಟ್ಯಗಳು',
        pricing: 'ಬೆಲೆಗಳು',
        solutions: 'ಪರಿಹಾರಗಳು',
        resources: 'ಸಂಪನ್ಮೂಲಗಳು',
        about: 'ಬಗ್ಗೆ',
        blog: 'ಬ್ಲಾಗ್',
        careers: 'ವೃತ್ತಿಗಳು',
        contact: 'ಸಂಪರ್ಕಿಸಿ',
        docs: 'ದಾಖಲಾತಿ',
        help: 'ಸಹಾಯ ಕೇಂದ್ರ',
        api: 'API ಉಲ್ಲೇಖ',
        status: 'ಸ್ಥಿತಿ',
        privacy: 'ಗೌಪ್ಯತೆ',
        terms: 'ನಿಯಮಗಳು',
        security: 'ಭದ್ರತೆ'
      },
      copyright: 'ಸೋಮಾ ಟೆಕ್ನಾಲಜೀಸ್. ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.'
    }
  },
  // Common UI elements
  common: {
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    save: 'ಉಳಿಸಿ',
    cancel: 'ರದ್ದುಮಾಡಿ',
    delete: 'ಅಳಿಸಿ',
    edit: 'ಸಂಪಾದಿಸಿ',
    add: 'ಸೇರಿಸಿ',
    create: 'ರಚಿಸಿ',
    update: 'ನವೀಕರಿಸಿ',
    search: 'ಹುಡುಕಿ',
    filter: 'ಫಿಲ್ಟರ್',
    export: 'ರಫ್ತು',
    import: 'ಆಮದು',
    print: 'ಮುದ್ರಿಸಿ',
    download: 'ಡೌನ್‌ಲೋಡ್',
    upload: 'ಅಪ್‌ಲೋಡ್',
    submit: 'ಸಲ್ಲಿಸಿ',
    reset: 'ಮರುಹೊಂದಿಸಿ',
    clear: 'ತೆರವುಗೊಳಿಸಿ',
    confirm: 'ದೃಢೀಕರಿಸಿ',
    yes: 'ಹೌದು',
    no: 'ಇಲ್ಲ',
    ok: 'ಸರಿ',
    close: 'ಮುಚ್ಚಿ',
    back: 'ಹಿಂದೆ',
    next: 'ಮುಂದೆ',
    previous: 'ಹಿಂದಿನ',
    finish: 'ಮುಗಿಸಿ',
    continue: 'ಮುಂದುವರಿಸಿ',
    skip: 'ಬಿಟ್ಟುಬಿಡಿ',
    retry: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
    refresh: 'ರಿಫ್ರೆಶ್',
    view: 'ವೀಕ್ಷಿಸಿ',
    details: 'ವಿವರಗಳು',
    settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    help: 'ಸಹಾಯ',
    about: 'ಬಗ್ಗೆ',
    contact: 'ಸಂಪರ್ಕಿಸಿ',
    support: 'ಬೆಂಬಲ',
    feedback: 'ಪ್ರತಿಕ್ರಿಯೆ',
    logout: 'ಲಾಗ್ ಔಟ್',
    login: 'ಲಾಗಿನ್',
    register: 'ನೋಂದಣಿ',
    profile: 'ಪ್ರೊಫೈಲ್',
    account: 'ಖಾತೆ',
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    home: 'ಮುಖ್ಯಪುಟ',
    menu: 'ಮೆನು',
    navigation: 'ನ್ಯಾವಿಗೇಷನ್',
    sidebar: 'ಸೈಡ್‌ಬಾರ್',
    header: 'ಹೆಡರ್',
    footer: 'ಫೂಟರ್',
    content: 'ವಿಷಯ',
    main: 'ಮುಖ್ಯ',
    section: 'ವಿಭಾಗ',
    page: 'ಪುಟ',
    tab: 'ಟ್ಯಾಬ್',
    panel: 'ಪ್ಯಾನೆಲ್',
    modal: 'ಮೋಡಲ್',
    dialog: 'ಸಂವಾದ',
    form: 'ಫಾರ್ಮ್',
    field: 'ಕ್ಷೇತ್ರ',
    input: 'ಇನ್‌ಪುಟ್',
    select: 'ಆಯ್ಕೆಮಾಡಿ',
    option: 'ಆಯ್ಕೆ',
    checkbox: 'ಚೆಕ್‌ಬಾಕ್ಸ್',
    radio: 'ರೇಡಿಯೋ',
    button: 'ಬಟನ್',
    link: 'ಲಿಂಕ್',
    image: 'ಚಿತ್ರ',
    icon: 'ಐಕಾನ್',
    text: 'ಪಠ್ಯ',
    title: 'ಶೀರ್ಷಿಕೆ',
    description: 'ವಿವರಣೆ',
    name: 'ಹೆಸರು',
    email: 'ಇಮೇಲ್',
    phone: 'ಫೋನ್',
    address: 'ವಿಳಾಸ',
    city: 'ನಗರ',
    state: 'ರಾಜ್ಯ',
    country: 'ದೇಶ',
    zipcode: 'ಪಿನ್ ಕೋಡ್',
    date: 'ದಿನಾಂಕ',
    time: 'ಸಮಯ',
    datetime: 'ದಿನಾಂಕ ಮತ್ತು ಸಮಯ',
    status: 'ಸ್ಥಿತಿ',
    type: 'ಪ್ರಕಾರ',
    category: 'ವರ್ಗ',
    priority: 'ಆದ್ಯತೆ',
    quantity: 'ಪ್ರಮಾಣ',
    price: 'ಬೆಲೆ',
    amount: 'ಮೊತ್ತ',
    total: 'ಒಟ್ಟು',
    subtotal: 'ಉಪ ಒಟ್ಟು',
    tax: 'ತೆರಿಗೆ',
    discount: 'ರಿಯಾಯಿತಿ',
    currency: 'ಕರೆನ್ಸಿ',
    unit: 'ಘಟಕ',
    notes: 'ಟಿಪ್ಪಣಿಗಳು',
    comments: 'ಕಾಮೆಂಟ್‌ಗಳು',
    tags: 'ಟ್ಯಾಗ್‌ಗಳು',
    actions: 'ಕ್ರಿಯೆಗಳು',
    options: 'ಆಯ್ಕೆಗಳು',
    preferences: 'ಆದ್ಯತೆಗಳು',
    configuration: 'ಕಾನ್ಫಿಗರೇಷನ್',
    advanced: 'ಸುಧಾರಿತ',
    basic: 'ಮೂಲಭೂತ',
    general: 'ಸಾಮಾನ್ಯ',
    security: 'ಭದ್ರತೆ',
    privacy: 'ಗೌಪ್ಯತೆ',
    notifications: 'ಅಧಿಸೂಚನೆಗಳು',
    alerts: 'ಎಚ್ಚರಿಕೆಗಳು',
    warnings: 'ಎಚ್ಚರಿಕೆಗಳು',
    errors: 'ದೋಷಗಳು',
    success: 'ಯಶಸ್ಸು',
    info: 'ಮಾಹಿತಿ',
    tips: 'ಸಲಹೆಗಳು',
    guides: 'ಮಾರ್ಗದರ್ಶಿಗಳು',
    tutorials: 'ಟ್ಯುಟೋರಿಯಲ್‌ಗಳು',
    documentation: 'ದಾಖಲೀಕರಣ',
    faq: 'ಆಗಾಗ್ಗೆ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು',
    terms: 'ನಿಯಮಗಳು',
    conditions: 'ಷರತ್ತುಗಳು',
    policy: 'ನೀತಿ',
    agreement: 'ಒಪ್ಪಂದ',
    license: 'ಪರವಾನಗಿ',
    version: 'ಆವೃತ್ತಿ',
    active: 'ಸಕ್ರಿಯ',
    inactive: 'ನಿಷ್ಕ್ರಿಯ',
    pending: 'ಬಾಕಿ',
    completed: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
    failed: 'ವಿಫಲವಾಗಿದೆ',
    cancelled: 'ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ',
    approved: 'ಅನುಮೋದಿಸಲಾಗಿದೆ',
    rejected: 'ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
    draft: 'ಕರಡು',
    published: 'ಪ್ರಕಟಿಸಲಾಗಿದೆ',
    archived: 'ಆರ್ಕೈವ್ ಮಾಡಲಾಗಿದೆ',
    deleted: 'ಅಳಿಸಲಾಗಿದೆ',
    new: 'ಹೊಸ',
    old: 'ಹಳೆಯ',
    recent: 'ಇತ್ತೀಚಿನ',
    latest: 'ಇತ್ತೀಚಿನ',
    popular: 'ಜನಪ್ರಿಯ',
    featured: 'ವೈಶಿಷ್ಟ್ಯಗೊಳಿಸಲಾದ',
    recommended: 'ಶಿಫಾರಸು ಮಾಡಲಾದ',
    trending: 'ಟ್ರೆಂಡಿಂಗ್',
    high: 'ಹೆಚ್ಚು',
    medium: 'ಮಧ್ಯಮ',
    low: 'ಕಡಿಮೆ',
    urgent: 'ತುರ್ತು',
    normal: 'ಸಾಮಾನ್ಯ',
    critical: 'ನಿರ್ಣಾಯಕ',
    important: 'ಮುಖ್ಯ',
    optional: 'ಐಚ್ಛಿಕ',
    required: 'ಅಗತ್ಯವಿರುವ',
    mandatory: 'ಕಡ್ಡಾಯ',
    public: 'ಸಾರ್ವಜನಿಕ',
    private: 'ಖಾಸಗಿ',
    shared: 'ಹಂಚಿಕೊಳ್ಳಲಾದ',
    personal: 'ವೈಯಕ್ತಿಕ',
    business: 'ವ್ಯಾಪಾರ',
    professional: 'ವೃತ್ತಿಪರ',
    enterprise: 'ಎಂಟರ್‌ಪ್ರೈಸ್',
    premium: 'ಪ್ರೀಮಿಯಂ',
    free: 'ಉಚಿತ',
    paid: 'ಪಾವತಿ',
    trial: 'ಪ್ರಯೋಗ',
    demo: 'ಡೆಮೋ',
    beta: 'ಬೀಟಾ',
    alpha: 'ಆಲ್ಫಾ',
    stable: 'ಸ್ಥಿರ',
    development: 'ಅಭಿವೃದ್ಧಿ',
    production: 'ಉತ್ಪಾದನೆ',
    testing: 'ಪರೀಕ್ಷೆ',
    staging: 'ಸ್ಟೇಜಿಂಗ್',
    maintenance: 'ನಿರ್ವಹಣೆ',
    backup: 'ಬ್ಯಾಕಪ್',
    restore: 'ಮರುಸ್ಥಾಪನೆ',
    sync: 'ಸಿಂಕ್',
    migrate: 'ಮೈಗ್ರೇಟ್',
    transfer: 'ವರ್ಗಾವಣೆ',
    copy: 'ನಕಲು',
    move: 'ಸರಿಸಿ',
    duplicate: 'ನಕಲು',
    clone: 'ಕ್ಲೋನ್',
    merge: 'ವಿಲೀನ',
    split: 'ವಿಭಜನೆ',
    combine: 'ಸಂಯೋಜಿಸಿ',
    separate: 'ಪ್ರತ್ಯೇಕಿಸಿ',
    group: 'ಗುಂಪು',
    ungroup: 'ಗುಂಪುರಹಿತ',
    sort: 'ವಿಂಗಡಿಸಿ',
    order: 'ಆದೇಶ',
    arrange: 'ವ್ಯವಸ್ಥೆಗೊಳಿಸಿ',
    organize: 'ಸಂಘಟಿಸಿ',
    manage: 'ನಿರ್ವಹಿಸಿ',
    control: 'ನಿಯಂತ್ರಣ',
    monitor: 'ಮಾನಿಟರ್',
    track: 'ಟ್ರ್ಯಾಕ್',
    analyze: 'ವಿಶ್ಲೇಷಿಸಿ',
    report: 'ವರದಿ',
    statistics: 'ಅಂಕಿಅಂಶಗಳು',
    metrics: 'ಮೆಟ್ರಿಕ್ಸ್',
    analytics: 'ಅನಾಲಿಟಿಕ್ಸ್',
    insights: 'ಒಳನೋಟಗಳು',
    trends: 'ಪ್ರವೃತ್ತಿಗಳು',
    patterns: 'ಮಾದರಿಗಳು',
    data: 'ಡೇಟಾ',
    information: 'ಮಾಹಿತಿ',
    content: 'ವಿಷಯ',
    media: 'ಮಾಧ್ಯಮ',
    files: 'ಫೈಲ್‌ಗಳು',
    documents: 'ದಾಖಲೆಗಳು',
    images: 'ಚಿತ್ರಗಳು',
    videos: 'ವೀಡಿಯೊಗಳು',
    audio: 'ಆಡಿಯೊ',
    attachments: 'ಲಗತ್ತುಗಳು',
    downloads: 'ಡೌನ್‌ಲೋಡ್‌ಗಳು',
    uploads: 'ಅಪ್‌ಲೋಡ್‌ಗಳು',
    storage: 'ಸಂಗ್ರಹಣೆ',
    memory: 'ಮೆಮೊರಿ',
    cache: 'ಕ್ಯಾಶ್',
    database: 'ಡೇಟಾಬೇಸ್',
    server: 'ಸರ್ವರ್',
    client: 'ಕ್ಲೈಂಟ್',
    network: 'ನೆಟ್‌ವರ್ಕ್',
    internet: 'ಇಂಟರ್ನೆಟ್',
    connection: 'ಸಂಪರ್ಕ',
    bandwidth: 'ಬ್ಯಾಂಡ್‌ವಿಡ್ತ್',
    speed: 'ವೇಗ',
    performance: 'ಕಾರ್ಯಕ್ಷಮತೆ',
    optimization: 'ಆಪ್ಟಿಮೈಸೇಷನ್',
    efficiency: 'ದಕ್ಷತೆ',
    quality: 'ಗುಣಮಟ್ಟ',
    reliability: 'ವಿಶ್ವಾಸಾರ್ಹತೆ',
    stability: 'ಸ್ಥಿರತೆ',
    safety: 'ಸುರಕ್ಷತೆ',
    protection: 'ರಕ್ಷಣೆ',
    encryption: 'ಎನ್‌ಕ್ರಿಪ್ಷನ್',
    authentication: 'ದೃಢೀಕರಣ',
    authorization: 'ಅಧಿಕಾರ',
    permission: 'ಅನುಮತಿ',
    access: 'ಪ್ರವೇಶ',
    rights: 'ಹಕ್ಕುಗಳು',
    privileges: 'ಸವಲತ್ತುಗಳು',
    roles: 'ಪಾತ್ರಗಳು',
    users: 'ಬಳಕೆದಾರರು',
    groups: 'ಗುಂಪುಗಳು',
    teams: 'ತಂಡಗಳು',
    organizations: 'ಸಂಸ್ಥೆಗಳು',
    companies: 'ಕಂಪನಿಗಳು',
    departments: 'ವಿಭಾಗಗಳು',
    divisions: 'ವಿಭಾಗಗಳು',
    branches: 'ಶಾಖೆಗಳು',
    locations: 'ಸ್ಥಳಗಳು',
    regions: 'ಪ್ರದೇಶಗಳು',
    countries: 'ದೇಶಗಳು',
    languages: 'ಭಾಷೆಗಳು',
    currencies: 'ಕರೆನ್ಸಿಗಳು',
    timezones: 'ಸಮಯ ವಲಯಗಳು',
    formats: 'ಸ್ವರೂಪಗಳು',
    templates: 'ಟೆಂಪ್ಲೇಟ್‌ಗಳು',
    themes: 'ಥೀಮ್‌ಗಳು',
    styles: 'ಶೈಲಿಗಳು',
    layouts: 'ಲೇಔಟ್‌ಗಳು',
    designs: 'ವಿನ್ಯಾಸಗಳು',
    colors: 'ಬಣ್ಣಗಳು',
    fonts: 'ಫಾಂಟ್‌ಗಳು',
    sizes: 'ಗಾತ್ರಗಳು',
    dimensions: 'ಆಯಾಮಗಳು',
    positions: 'ಸ್ಥಾನಗಳು',
    alignments: 'ಜೋಡಣೆಗಳು',
    margins: 'ಅಂಚುಗಳು',
    padding: 'ಪ್ಯಾಡಿಂಗ್',
    borders: 'ಗಡಿಗಳು',
    shadows: 'ನೆರಳುಗಳು',
    effects: 'ಪರಿಣಾಮಗಳು',
    animations: 'ಅನಿಮೇಷನ್‌ಗಳು',
    transitions: 'ಪರಿವರ್ತನೆಗಳು',
    interactions: 'ಸಂವಹನಗಳು',
    gestures: 'ಸನ್ನೆಗಳು',
    shortcuts: 'ಶಾರ್ಟ್‌ಕಟ್‌ಗಳು',
    hotkeys: 'ಹಾಟ್‌ಕೀಗಳು',
    commands: 'ಆಜ್ಞೆಗಳು',
    functions: 'ಕಾರ್ಯಗಳು',
    features: 'ವೈಶಿಷ್ಟ್ಯಗಳು',
    capabilities: 'ಸಾಮರ್ಥ್ಯಗಳು',
    tools: 'ಉಪಕರಣಗಳು',
    utilities: 'ಉಪಯುಕ್ತತೆಗಳು',
    widgets: 'ವಿಜೆಟ್‌ಗಳು',
    components: 'ಘಟಕಗಳು',
    modules: 'ಮಾಡ್ಯೂಲ್‌ಗಳು',
    plugins: 'ಪ್ಲಗಿನ್‌ಗಳು',
    extensions: 'ವಿಸ್ತರಣೆಗಳು',
    addons: 'ಆಡ್‌ಆನ್‌ಗಳು',
    integrations: 'ಏಕೀಕರಣಗಳು',
    connections: 'ಸಂಪರ್ಕಗಳು',
    apis: 'ಎಪಿಐಗಳು',
    services: 'ಸೇವೆಗಳು',
    applications: 'ಅಪ್ಲಿಕೇಷನ್‌ಗಳು',
    software: 'ಸಾಫ್ಟ್‌ವೇರ್',
    hardware: 'ಹಾರ್ಡ್‌ವೇರ್',
    devices: 'ಸಾಧನಗಳು',
    platforms: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳು',
    systems: 'ವ್ಯವಸ್ಥೆಗಳು',
    frameworks: 'ಫ್ರೇಮ್‌ವರ್ಕ್‌ಗಳು',
    libraries: 'ಗ್ರಂಥಾಲಯಗಳು',
    packages: 'ಪ್ಯಾಕೇಜ್‌ಗಳು',
    dependencies: 'ಅವಲಂಬನೆಗಳು',
    requirements: 'ಅವಶ್ಯಕತೆಗಳು',
    specifications: 'ವಿಶೇಷಣಗಳು',
    standards: 'ಮಾನದಂಡಗಳು',
    protocols: 'ಪ್ರೋಟೋಕಾಲ್‌ಗಳು',
    schemas: 'ಸ್ಕೀಮಾಗಳು',
    structures: 'ರಚನೆಗಳು',
    models: 'ಮಾದರಿಗಳು',
    entities: 'ಘಟಕಗಳು',
    objects: 'ವಸ್ತುಗಳು',
    items: 'ವಸ್ತುಗಳು',
    elements: 'ಅಂಶಗಳು',
    parts: 'ಭಾಗಗಳು',
    pieces: 'ತುಣುಕುಗಳು',
    fragments: 'ತುಣುಕುಗಳು',
    sections: 'ವಿಭಾಗಗಳು',
    chapters: 'ಅಧ್ಯಾಯಗಳು',
    pages: 'ಪುಟಗಳು',
    articles: 'ಲೇಖನಗಳು',
    posts: 'ಪೋಸ್ಟ್‌ಗಳು',
    entries: 'ನಮೂದುಗಳು',
    records: 'ದಾಖಲೆಗಳು',
    logs: 'ಲಾಗ್‌ಗಳು',
    history: 'ಇತಿಹಾಸ',
    timeline: 'ಟೈಮ್‌ಲೈನ್',
    schedule: 'ವೇಳಾಪಟ್ಟಿ',
    calendar: 'ಕ್ಯಾಲೆಂಡರ್',
    events: 'ಘಟನೆಗಳು',
    appointments: 'ನೇಮಕಾತಿಗಳು',
    meetings: 'ಸಭೆಗಳು',
    conferences: 'ಸಮ್ಮೇಳನಗಳು',
    calls: 'ಕರೆಗಳು',
    messages: 'ಸಂದೇಶಗಳು',
    emails: 'ಇಮೇಲ್‌ಗಳು',
    reminders: 'ಜ್ಞಾಪನೆಗಳು',
    tasks: 'ಕಾರ್ಯಗಳು',
    todos: 'ಮಾಡಬೇಕಾದವುಗಳು',
    projects: 'ಯೋಜನೆಗಳು',
    workflows: 'ಕಾರ್ಯಪ್ರವಾಹಗಳು',
    processes: 'ಪ್ರಕ್ರಿಯೆಗಳು',
    procedures: 'ಕಾರ್ಯವಿಧಾನಗಳು',
    steps: 'ಹಂತಗಳು',
    stages: 'ಹಂತಗಳು',
    phases: 'ಹಂತಗಳು',
    milestones: 'ಮೈಲಿಗಲ್ಲುಗಳು',
    deadlines: 'ಅವಧಿಗಳು',
    goals: 'ಗುರಿಗಳು',
    objectives: 'ಉದ್ದೇಶಗಳು',
    targets: 'ಗುರಿಗಳು',
    achievements: 'ಸಾಧನೆಗಳು',
    results: 'ಫಲಿತಾಂಶಗಳು',
    outcomes: 'ಫಲಿತಾಂಶಗಳು',
    outputs: 'ಔಟ್‌ಪುಟ್‌ಗಳು',
    inputs: 'ಇನ್‌ಪುಟ್‌ಗಳು',
    resources: 'ಸಂಪನ್ಮೂಲಗಳು',
    assets: 'ಆಸ್ತಿಗಳು',
    materials: 'ವಸ್ತುಗಳು',
    supplies: 'ಸರಬರಾಜುಗಳು',
    equipment: 'ಸಲಕರಣೆಗಳು',
    instruments: 'ಉಪಕರಣಗಳು',
    machines: 'ಯಂತ್ರಗಳು',
    vehicles: 'ವಾಹನಗಳು',
    facilities: 'ಸೌಲಭ್ಯಗಳು',
    buildings: 'ಕಟ್ಟಡಗಳು',
    rooms: 'ಕೊಠಡಿಗಳು',
    spaces: 'ಸ್ಥಳಗಳು',
    areas: 'ಪ್ರದೇಶಗಳು',
    zones: 'ವಲಯಗಳು',
    done: 'ಮುಗಿದಿದೆ',
    undone: 'ಮುಗಿಸದ',
    accomplished: 'ಸಾಧಿಸಲಾದ',
    unaccomplished: 'ಸಾಧಿಸದ'
  },

  // Navigation
  navigation: {
    home: 'ಮುಖ್ಯಪುಟ',
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    inventory: 'ದಾಸ್ತಾನು',
    orders: 'ಆದೇಶಗಳು',
    customers: 'ಗ್ರಾಹಕರು',
    suppliers: 'ಪೂರೈಕೆದಾರರು',
    purchases: 'ಖರೀದಿಗಳು',
    analytics: 'ಅನಾಲಿಟಿಕ್ಸ್',
    reports: 'ವರದಿಗಳು',
    settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    profile: 'ಪ್ರೊಫೈಲ್',
    logout: 'ಲಾಗ್ ಔಟ್',
    help: 'ಸಹಾಯ',
    support: 'ಬೆಂಬಲ'
  },

  // Authentication
  auth: {
    login: 'ಲಾಗಿನ್',
    register: 'ನೋಂದಣಿ',
    logout: 'ಲಾಗ್ ಔಟ್',
    forgotPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿದ್ದೀರಾ',
    resetPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ',
    changePassword: 'ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಿ',
    email: 'ಇಮೇಲ್',
    password: 'ಪಾಸ್‌ವರ್ಡ್',
    confirmPassword: 'ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ',
    rememberMe: 'ನನ್ನನ್ನು ನೆನಪಿಡಿ',
    loginButton: 'ಸೈನ್ ಇನ್',
    registerButton: 'ಸೈನ್ ಅಪ್',
    alreadyHaveAccount: 'ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?',
    dontHaveAccount: 'ಖಾತೆ ಇಲ್ಲವೇ?',
    signInHere: 'ಇಲ್ಲಿ ಸೈನ್ ಇನ್ ಮಾಡಿ',
    signUpHere: 'ಇಲ್ಲಿ ಸೈನ್ ಅಪ್ ಮಾಡಿ',
    invalidCredentials: 'ತಪ್ಪು ಇಮೇಲ್ ಅಥವಾ ಪಾಸ್‌ವರ್ಡ್',
    accountCreated: 'ಖಾತೆ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ',
    passwordResetSent: 'ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ',
    passwordChanged: 'ಪಾಸ್‌ವರ್ಡ್ ಯಶಸ್ವಿಯಾಗಿ ಬದಲಾಯಿಸಲಾಗಿದೆ',
    login_page: {
      title: 'ಎಂಟರ್‌ಪ್ರೈಸ್ ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್.',
      features: {
        speed: { title: 'ಸ್ಥಳೀಯ ವೇಗ', desc: 'ಭಾರತೀಯ ಮಾರುಕಟ್ಟೆಗಾಗಿ ನಿರ್ಮಿಸಲಾದ ಉನ್ನತ-ಕಾರ್ಯಕ್ಷಮತೆಯ ವಾಸ್ತುಶಿಲ್ಪ.' },
        trust: { title: 'ಎನ್‌ಕ್ರಿಪ್ಟ್ ಮಾಡಲಾದ ಟ್ರಸ್ಟ್', desc: 'ನಿಮ್ಮ ಸೂಕ್ಷ್ಮ ಹಣಕಾಸು ಡೇಟಾಕ್ಕಾಗಿ ಬ್ಯಾಂಕ್-ಗ್ರೇಡ್ ಭದ್ರತಾ ಪ್ರೋಟೋಕಾಲ್‌ಗಳು.' }
      },
      serving: '10,000+ ಭಾರತೀಯ ಉದ್ಯಮಗಳಿಗೆ ಸೇವೆ ಸಲ್ಲಿಸುತ್ತಿದೆ',
      welcome: 'ಸ್ವಾಗತ.',
      subtitle: 'ಅಧಿಕೃತ ಪ್ರವೇಶ ಮಾತ್ರ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ರುಜುವಾತುಗಳನ್ನು ಪರಿಶೀಲಿಸಿ.',
      email_label: 'ಇಮೇಲ್ ಆರ್ಕಿಟೆಕ್ಚರ್',
      password_label: 'ಸೆಕ್ಯುರಿಟಿ ಕೀ',
      reset_access: 'ಪ್ರವೇಶವನ್ನು ಮರುಹೊಂದಿಸಿ',
      submit: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಪ್ರಾರಂಭಿಸಿ',
      verifying: 'ರುಜುವಾತುಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
      third_party: 'ಥರ್ಡ್ ಪಾರ್ಟಿ ಆಥ್',
      verify_google: 'Google ನೊಂದಿಗೆ ಪರಿಶೀಲಿಸಿ',
      no_account: 'ಖಾತೆ ಇಲ್ಲವೇ?',
      open_account: 'ಎಂಟರ್‌ಪ್ರೈಸ್ ಖಾತೆಯನ್ನು ತೆರೆಯಿರಿ'
    },
    register_page: {
      title: 'ಎಲೈಟ್ ಶ್ರೇಣಿಗೆ ಸೇರಿ.',
      features: {
        gst: { title: 'GST ಆಪ್ಟಿಮೈಸ್ಡ್', desc: 'ಎಂಟರ್‌ಪ್ರೈಸ್-ಗ್ರೇಡ್ ಕಂಪ್ಲೈಯನ್ಸ್ ಎಂಜಿನ್.' },
        sync: { title: 'ಅಟಾಮಿಕ್ ಸಿಂಕ್', desc: 'ಸಾಧನಗಳಾದ್ಯಂತ ತ್ವರಿತ ಡೇಟಾ ಪ್ರಸರಣ.' }
      },
      testimonial: '"2 ರಿಂದ 20 ಸ್ಥಳಗಳಿಗೆ ಸ್ಕೇಲ್ ಮಾಡಲು ನಮಗೆ ಬೇಕಾದ ಮೂಲಸೌಕರ್ಯ ಸೋಮಾ."',
      testimonial_author: 'ರಾಜೇಶ್ ಕುಮಾರ್',
      testimonial_role: 'ಮಾಲೀಕ, ಗ್ಲೋಬಲ್ ಟ್ರೇಡರ್ಸ್',
      form_title: 'ಖಾತೆ ತೆರೆಯಿರಿ.',
      form_subtitle: 'ಎಲೈಟ್ 14-ದಿನದ ಪ್ರಯೋಗದೊಂದಿಗೆ ನಿಮ್ಮ ವ್ಯಾಪಾರ ವಾಸ್ತುಶಿಲ್ಪವನ್ನು ಸುರಕ್ಷಿತಗೊಳಿಸಿ.',
      labels: {
        first_name: 'ಮೊದಲ ಹೆಸರು',
        last_name: 'ಕೊನೆಯ ಹೆಸರು',
        email: 'ಕಾರ್ಪೊರೇಟ್ ಇಮೇಲ್',
        password: 'ಸೆಕ್ಯುರಿಟಿ ಕೀ',
        confirm_password: 'ಕೀ ದೃಢೀಕರಿಸಿ',
        business_name: 'ವ್ಯಾಪಾರ ಗುರುತು',
        phone: 'ಫೋನ್ ಸಂಖ್ಯೆ',
        entity_type: 'ಘಟಕ ಪ್ರಕಾರ',
        sector: 'ವಲಯ'
      },
      placeholders: {
        select_type: 'ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        select_industry: 'ಉದ್ಯಮವನ್ನು ಆಯ್ಕೆಮಾಡಿ'
      },
      submit: 'ಪ್ರವೇಶವನ್ನು ವಿನಂತಿಸಿ',
      already_registered: 'ಈಗಾಗಲೇ ನೋಂದಾಯಿಸಲಾಗಿದೆಯೇ?',
      sign_in: 'ಅಧಿಕೃತ ಸೈನ್ ಇನ್'
    }
  },

  // Business Management
  business: {
    // Merged existing keys
    name: 'ವ್ಯಾಪಾರದ ಹೆಸರು',
    type: 'ವ್ಯಾಪಾರದ ಪ್ರಕಾರ',
    category: 'ವರ್ಗ',
    description: 'ವಿವರಣೆ',
    address: 'ವಿಳಾಸ',
    phone: 'ಫೋನ್ ಸಂಖ್ಯೆ',
    email: 'ಇಮೇಲ್ ವಿಳಾಸ',
    website: 'ವೆಬ್‌ಸೈಟ್',
    gstNumber: 'ಜಿಎಸ್ಟಿ ಸಂಖ್ಯೆ',
    panNumber: 'ಪ್ಯಾನ್ ಸಂಖ್ಯೆ',
    bankAccount: 'ಬ್ಯಾಂಕ್ ಖಾತೆ',
    ifscCode: 'ಐಎಫ್‌ಎಸ್‌ಸಿ ಕೋಡ್',
    accountNumber: 'ಖಾತೆ ಸಂಖ್ಯೆ',
    accountHolder: 'ಖಾತೆದಾರರ ಹೆಸರು',

    // New keys from en.js
  profile: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್",
edit_profile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
create_profile: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
edit_business_profile: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
create_business_profile: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
no_profile_found: "ಯಾವುದೇ ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಕಂಡುಬಂದಿಲ್ಲ",
no_business_profile: "ಯಾವುದೇ ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಕಂಡುಬಂದಿಲ್ಲ",
no_business_profile_description: "ನೀವು ಇನ್ನೂ ನಿಮ್ಮ ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಸೆಟ್ ಮಾಡಿಲ್ಲ. ಎಲ್ಲಾ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಬಳಸಲು ಒಂದು ಪ್ರೊಫೈಲ್ ರಚಿಸಿ.",
go_back: "ಹಿಂದೆ ಹೋಗಿ",
basic_info: "ಮೂಲ ಮಾಹಿತಿ",
business_name: "ವ್ಯವಹಾರದ ಹೆಸರು",
enter_name: "ವ್ಯವಹಾರದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
business_type: "ವ್ಯವಹಾರದ ಪ್ರಕಾರ",
select_type: "ವ್ಯವಹಾರದ ಪ್ರಕಾರ ಆಯ್ಕೆಮಾಡಿ",
enter_email: "ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
enter_phone: "ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
enter_address: "ಪೂರ್ಣ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
select_category: "ವರ್ಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
annual_turnover: "ವಾರ್ಷಿಕ ವಹಿವಾಟು",
select_turnover: "ವಹಿವಾಟಿನ ಶ್ರೇಣಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
turnover_range_0_5L: "₹0 - ₹5 ಲಕ್ಷ",
turnover_range_5L_20L: "₹5 ಲಕ್ಷ - ₹20 ಲಕ್ಷ",
turnover_range_20L_1Cr: "₹20 ಲಕ್ಷ - ₹1 ಕೋಟಿ",
turnover_range_1Cr_plus: "₹1 ಕೋಟಿ ಮೇಲ್ಪಟ್ಟು",
fetch_profile_error: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಪಡೆಯಲು ವಿಫಲವಾಗಿದೆ",
fetch_gst_error: "GST ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಪಡೆಯಲು ವಿಫಲವಾಗಿದೆ",
toggle_gst_error: "GST ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಆನ್/ಆಫ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
update_gst_status_error: "GST ಸ್ಥಿತಿಯನ್ನು ಅಪ್ಡೇಟ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
save_error: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ",
gst_registered: "GST ನೋಂದಾಯಿಸಲಾಗಿದೆ",
gst_number: "GST ಸಂಖ್ಯೆ",
registration_date: "ನೋಂದಣಿ ದಿನಾಂಕ",
flower_vendor: "ಹೂವಿನ ವ್ಯಾಪಾರಿ",
grocery_store: "ಕಿರಾಣಿ ಅಂಗಡಿ",
textile_shop: "ವಸ್ತ್ರ ಅಂಗಡಿ",
hardware_store: "ಹಾರ್ಡ್‌ವೇರ್ ಅಂಗಡಿ",
electronics_shop: "ಇಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಅಂಗಡಿ",
other: "ಇತರೆ",
retailer: "ಚಿಲ್ಲರೆ ವ್ಯಾಪಾರಿ",
wholesaler: "ಹೊಲ್ಸೇಲ್ ವ್ಯಾಪಾರಿ",
manufacturer: "ತಯಾರಕ",
service_provider: "ಸೇವಾ ಒದಗಿಸುವವರು",
gst_configuration: "GST ಸಂರಚನೆ",
enabled: "ಸಕ್ರಿಯ",
disabled: "ನಿಷ್ಕ್ರಿಯ",
gstin_number: "GSTIN ಸಂಖ್ಯೆ",
gstin_placeholder: "22AAAAA0000A1Z5",
gst_registration_date: "GST ನೋಂದಾಯ ದಿನಾಂಕ",
default_cgst: "ಡೀಫಾಲ್ಟ್ CGST (%)",
default_sgst: "ಡೀಫಾಲ್ಟ್ SGST (%)",
default_igst: "ಡೀಫಾಲ್ಟ್ IGST (%)",
auto_sync: "GST ಪೋರ್ಟಲ್ ಜೊತೆ ಬಿಲ್ಲುಗಳನ್ನು ಸ್ವಯಂ-ಸಿಂಕ್ ಮಾಡಿ",
business_settings: "ವ್ಯವಹಾರ ಸೆಟ್ಟಿಂಗ್ಗಳು",
manage_business_preferences: "ನಿಮ್ಮ ವ್ಯವಹಾರ ಆದ್ಯತೆಗಳು ಮತ್ತು ಸಂರಚನೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
general_settings: "ಸಾಮಾನ್ಯ ಸೆಟ್ಟಿಂಗ್ಗಳು",
configure_general_settings: "ಮೂಲ ವ್ಯವಹಾರ ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಸಂರಚಿಸಿ",
language: "ಭಾಷೆ",
select_language: "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
currency: "ಕರೆನ್ಸಿ",
select_currency: "ಕರೆನ್ಸಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
timezone: "ಸಮಯ ವಲಯ",
select_timezone: "ಸಮಯ ವಲಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
notifications: "ಅಧಿಸೂಚನೆಗಳು",
manage_notification_preferences: "ಅಧಿಸೂಚನೆ ಆದ್ಯತೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
low_stock_alerts: "ಕಡಿಮೆ ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆಗಳು",
low_stock_description: "ಸ್ಟಾಕ್ ಕಡಿಮೆಯಾದಾಗ ಅಧಿಸೂಚನೆ ಪಡೆಯಿರಿ",
expiring_items: "ಅವಧಿ ಮುಗಿಯುತ್ತಿರುವ ವಸ್ತುಗಳು",
expiring_items_description: "ಅವಧಿ ಸಮೀಪಿಸುತ್ತಿರುವ ವಸ್ತುಗಳ ಬಗ್ಗೆ ಅಧಿಸೂಚನೆ ಪಡೆಯಿರಿ",
order_updates: "ಆರ್ಡರ್ ಅಪ್ಡೇಟ್‌ಗಳು",
order_updates_description: "ಹೊಸ ಆರ್ಡರ್‌ಗಳು ಮತ್ತು ಸ್ಥಿತಿ ಬದಲಾವಣೆಗಳ ಬಗ್ಗೆ ಅಧಿಸೂಚನೆ ಪಡೆಯಿರಿ",
save_changes: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
cancel: "ರದ್ದುಮಾಡಿ",
create_profile_btn: "ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
yes: "ಹೌದು",
no: "ಇಲ್ಲ",
n_a: "ಲಭ್ಯವಿಲ್ಲ",
settings_saved_successfully: "ಸೆಟ್ಟಿಂಗ್ಗಳು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲ್ಪಟ್ಟಿವೆ",
failed_to_save_settings: "ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ",
failed_to_load_settings: "ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
profile_updated: "ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್ಡೇಟ್ ಆಗಿದೆ",
business_profile_created: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ!",
error_saving: "ಉಳಿಸುವಾಗ ದೋಷ ಉಂಟಾಗಿದೆ",
error_creating: "ಪ್ರೊಫೈಲ್ ರಚಿಸುವಾಗ ದೋಷ ಉಂಟಾಗಿದೆ",
could_not_fetch_business_profile: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಪಡೆಯಲಾಗಲಿಲ್ಲ",
business_profile_not_found: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಕಂಡುಬಂದಿಲ್ಲ",
not_provided: "ಒದಗಿಸಲಾಗಿಲ್ಲ",
business_label: "ವ್ಯವಹಾರ"
  },

 profile_settings: {
  title: "ಸೆಟ್ಟಿಂಗ್ಗಳು",
  description: "ನಿಮ್ಮ ಖಾತೆ ಮತ್ತು ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಆದ್ಯತೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ.",
  my_profile: "ನನ್ನ ಪ್ರೊಫೈಲ್",
  my_profile_desc: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ ಮತ್ತು ಅವತಾರ್",
  preferences: "ಆದ್ಯತೆಗಳು",
  preferences_desc: "ಥೀಮ್, ಭಾಷೆ ಮತ್ತು ಅಧಿಸೂಚನೆಗಳು",
  preferences_page_desc: "ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ನಲ್ಲಿ ನಿಮ್ಮ ಅನುಭವವನ್ನು ಕಸ್ಟಮೈಸ್ ಮಾಡಿ.",
  security_privacy: "ಭದ್ರತೆ ಮತ್ತು ಗೌಪ್ಯತೆ",
  security_privacy_desc: "ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತು ಪ್ರವೇಶ ಭದ್ರತೆ",
  active_sessions: "ಸಕ್ರಿಯ ಸೆಷನ್‌ಗಳು",
  active_sessions_desc: "ಲಾಗಿನ್ ಆಗಿರುವ ಸಾಧನಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
  sign_out: "ಲಾಗ್ ಔಟ್",
  profile_details: "ಪ್ರೊಫೈಲ್ ವಿವರಗಳು",
  profile_details_desc: "ನಿಮ್ಮ ಫೋಟೋ ಮತ್ತು ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಅಪ್ಡೇಟ್ ಮಾಡಿ.",
  verified_account: "ಪರಿಶೀಲಿಸಲಾದ ಖಾತೆ",
  premium_plan: "ಪ್ರೀಮಿಯಂ ಪ್ಲಾನ್",
  first_name: "ಮೊದಲ ಹೆಸರು",
  last_name: "ಕೊನೆಯ ಹೆಸರು",
  email_address: "ಇಮೇಲ್ ವಿಳಾಸ",
  save_profile_changes: "ಪ್ರೊಫೈಲ್ ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
  saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
  preferences_title: "ಆದ್ಯತೆಗಳು",
  appearance: "ರೂಪ",
  theme: "ಥೀಮ್",
  select_theme: "ಥೀಮ್ ಆಯ್ಕೆಮಾಡಿ",
  light_mode: "ಲೈಟ್ ಮೋಡ್",
  dark_mode: "ಡಾರ್ಕ್ ಮೋಡ್",
  system_default: "ಸಿಸ್ಟಮ್ ಡೀಫಾಲ್ಟ್",
  display_language: "ಪ್ರದರ್ಶನ ಭಾಷೆ",
  select_language: "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  notifications: "ಅಧಿಸೂಚನೆಗಳು",
  email_notifications: "ಇಮೇಲ್ ಅಧಿಸೂಚನೆಗಳು",
  email_notifications_desc: "ಇಮೇಲ್ ಮೂಲಕ ಅಪ್ಡೇಟ್‌ಗಳನ್ನು ಪಡೆಯಿರಿ",
  push_notifications: "ಪುಷ್ ಅಧಿಸೂಚನೆಗಳು",
  push_notifications_desc: "ಬ್ರೌಸರ್ ಅಧಿಸೂಚನೆಗಳನ್ನು ಪಡೆಯಿರಿ",
  sms_notifications: "SMS ಅಧಿಸೂಚನೆಗಳು",
  sms_notifications_desc: "SMS ಮೂಲಕ ಅಪ್ಡೇಟ್‌ಗಳನ್ನು ಪಡೆಯಿರಿ",
  save_preferences: "ಆದ್ಯತೆಗಳನ್ನು ಉಳಿಸಿ",
  security_privacy_header: "ಭದ್ರತೆ ಮತ್ತು ಗೌಪ್ಯತೆ",
  security_privacy_header_desc: "ಭದ್ರ ಪಾಸ್‌ವರ್ಡ್ ಮೂಲಕ ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಬಲಪಡಿಸಿ.",
  password_label: "ಪಾಸ್‌ವರ್ಡ್",
  current_password: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್",
  new_password: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
  confirm_new_password: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
  update_password: "ಪಾಸ್‌ವರ್ಡ್ ಅಪ್ಡೇಟ್ ಮಾಡಿ",
  active_sessions_header: "ಸಕ್ರಿಯ ಸೆಷನ್‌ಗಳು",
  active_sessions_header_desc: "ನಿಮ್ಮ ಖಾತೆ ಪ್ರಸ್ತುತ ಲಾಗಿನ್ ಆಗಿರುವ ಸಾಧನಗಳನ್ನು ನಿರ್ವಹಿಸಿ.",
  this_device: "ಈ ಸಾಧನ",
  advanced_security: "ಉನ್ನತ ಭದ್ರತೆ",
  advanced_security_desc: "ಈ ಖಾತೆಗೆ ಎಲ್ಲಾ ಲಾಗಿನ್ ಪ್ರಯತ್ನಗಳಿಗೆ ಮಲ್ಟಿ-ಫ್ಯಾಕ್ಟರ್ ದೃಢೀಕರಣವನ್ನು ಅಗತ್ಯವಿರಿಸಿ.",
  enable_2fa: "2FA ದೃಢೀಕರಣವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
  customization_underway: "ಕಸ್ಟಮೈಜೆಷನ್ ಪ್ರಗತಿಯಲ್ಲಿದೆ",
  customization_underway_desc: "ನಿಮ್ಮ ಅನುಭವದ ಮೇಲೆ ಸಂಪೂರ್ಣ ನಿಯಂತ್ರಣ ನೀಡಲು ನಾವು ವಿವರವಾದ ಅಧಿಸೂಚನೆ ನಿಯಂತ್ರಣಗಳು ಮತ್ತು ಸಾಧನ ನಿರ್ವಹಣೆಯನ್ನು ನಿರ್ಮಿಸುತ್ತಿದ್ದೇವೆ."
},


  subscription_page: {
  subscription: "ಚಂದಾದಾರಿಕೆ",
  manage_subscription: "ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆ ಪ್ಲಾನ್ ಮತ್ತು ಬಿಲ್ಲಿಂಗ್ ವಿವರಗಳನ್ನು ನಿರ್ವಹಿಸಿ.",
  current_plan: "ಪ್ರಸ್ತುತ ಪ್ಲಾನ್",
  gst_settings: "GST ಸೆಟ್ಟಿಂಗ್ಗಳು",
  gst_settings_desc: "ನಿಮ್ಮ ವ್ಯವಹಾರ ಅನುಸರಣೆ ಮತ್ತು ಬಿಲ್ಲಿಂಗ್‌ಗಾಗಿ GST ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ನಿರ್ವಹಿಸಿ ಮತ್ತು GST ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ.",
  available_plans: "ಲಭ್ಯವಿರುವ ಪ್ಲಾನ್‌ಗಳು",
  plan_name: "ಪ್ಲಾನ್ ಹೆಸರು",
  free_tier: "ಉಚಿತ ಪ್ಲಾನ್",
  included_features: "ಒಳಗೊಂಡಿರುವ ವೈಶಿಷ್ಟ್ಯಗಳು",
  no_active_subscription: "ಯಾವುದೇ ಸಕ್ರಿಯ ಚಂದಾದಾರಿಕೆ ಕಂಡುಬಂದಿಲ್ಲ.",
  loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
  configure_gst: "GST ಸಂರಚಿಸಿ",
  processing: "ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿದೆ...",
  upgrade_plan: "ಪ್ಲಾನ್ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಿ",
  error_fetch_subscription: "ಚಂದಾದಾರಿಕೆ ವಿವರಗಳನ್ನು ಪಡೆಯಲು ವಿಫಲವಾಗಿದೆ.",
  error_generic_subscription: "ಚಂದಾದಾರಿಕೆ ವಿವರಗಳನ್ನು ಪಡೆಯುವಾಗ ದೋಷ ಉಂಟಾಗಿದೆ.",
  error_select_plan: "ಅಪ್ಗ್ರೇಡ್ ಮಾಡಲು ದಯವಿಟ್ಟು ಒಂದು ಪ್ಲಾನ್ ಆಯ್ಕೆಮಾಡಿ.",
  success_upgrade: "ಚಂದಾದಾರಿಕೆ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಲಾಗಿದೆ!",
  error_upgrade: "ಚಂದಾದಾರಿಕೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
  error_upgrade_generic: "ಚಂದಾದಾರಿಕೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡುವಾಗ ದೋಷ ಉಂಟಾಗಿದೆ.",
  error_business_not_found: "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಕಂಡುಬಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ಮೊದಲು ಒಂದು ಪ್ರೊಫೈಲ್ ರಚಿಸಿ.",
  error_fetch_business: "ವ್ಯವಹಾರ ವಿವರಗಳನ್ನು ಪಡೆಯಲು ವಿಫಲವಾಗಿದೆ."
},


  // Inventory Management
  inventory: {
    items: 'ವಸ್ತುಗಳು',
    item: 'ವಸ್ತು',
    product: 'ಉತ್ಪನ್ನ',
    service: 'ಸೇವೆ',
    sku: 'ಎಸ್‌ಕೆಯು',
    barcode: 'ಬಾರ್‌ಕೋಡ್',
    category: 'ವರ್ಗ',
    brand: 'ಬ್ರಾಂಡ್',
    unit: 'ಘಟಕ',
    quantity: 'ಪ್ರಮಾಣ',
    price: 'ಬೆಲೆ',
    cost: 'ವೆಚ್ಚ',
    sellingPrice: 'ಮಾರಾಟ ಬೆಲೆ',
    purchasePrice: 'ಖರೀದಿ ಬೆಲೆ',
    stock: 'ಸ್ಟಾಕ್',
    lowStock: 'ಕಡಿಮೆ ಸ್ಟಾಕ್',
    outOfStock: 'ಸ್ಟಾಕ್ ಇಲ್ಲ',
    inStock: 'ಸ್ಟಾಕ್‌ನಲ್ಲಿದೆ',
    stockAlert: 'ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆ',
    reorderLevel: 'ಮರುಆದೇಶ ಮಟ್ಟ',
    maxStock: 'ಗರಿಷ್ಠ ಸ್ಟಾಕ್',
    minStock: 'ಕನಿಷ್ಠ ಸ್ಟಾಕ್',
    addItem: 'ವಸ್ತು ಸೇರಿಸಿ',
    editItem: 'ವಸ್ತು ಸಂಪಾದಿಸಿ',
    deleteItem: 'ವಸ್ತು ಅಳಿಸಿ',
    bulkImport: 'ಬಲ್ಕ್ ಇಂಪೋರ್ಟ್',
    bulkExport: 'ಬಲ್ಕ್ ಎಕ್ಸ್‌ಪೋರ್ಟ್',
    stockUpdate: 'ಸ್ಟಾಕ್ ಅಪ್‌ಡೇಟ್',
    stockAdjustment: 'ಸ್ಟಾಕ್ ಹೊಂದಾಣಿಕೆ',
    stockTransfer: 'ಸ್ಟಾಕ್ ವರ್ಗಾವಣೆ'
  },

  // Time formatting
  time: {
    justNow: 'ಈಗಷ್ಟೇ',
    minutesAgo: '{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ',
    hoursAgo: '{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ',
    daysAgo: '{{count}} ದಿನಗಳ ಹಿಂದೆ',
    weeksAgo: '{{count}} ವಾರಗಳ ಹಿಂದೆ',
    monthsAgo: '{{count}} ತಿಂಗಳ ಹಿಂದೆ',
    yearsAgo: '{{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
  },

  // Pluralization
  items: {
    one: '{{count}} ವಸ್ತು',
    other: '{{count}} ವಸ್ತುಗಳು'
  },

  customers: {
    one: '{{count}} ಗ್ರಾಹಕ',
    other: '{{count}} ಗ್ರಾಹಕರು'
  },

  orders: {
    one: '{{count}} ಆದೇಶ',
    other: '{{count}} ಆದೇಶಗಳು'
  },
  dashboard: {
    "dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    "business_overview": "ವ್ಯಾಪಾರ ಅವಲೋಕನ",
    "action_required": "ಕ್ರಮ ಅಗತ್ಯವಿದೆ",
    "profile_incomplete_message": "ನಿಮ್ಮ ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ಅಪೂರ್ಣವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮುಂದುವರೆಯಲು ಅಗತ್ಯ ವಿವರಗಳನ್ನು ಒದಗಿಸಿ.",
    "complete_profile": "ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ",
    "quick_actions": "ತ್ವರಿತ ಕ್ರಮಗಳು",
    "add_sale": "ಮಾರಾಟ ಸೇರಿಸಿ",
    "manage_stock": "ಸ್ಟಾಕ್ ನಿರ್ವಹಿಸಿ",
    "view_orders": "ಆದೇಶಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    "todays_overview": "ಇಂದಿನ ಅವಲೋಕನ",
    "weeks_overview": "ಈ ವಾರದ ಅವಲೋಕನ",
    "months_overview": "ಈ ತಿಂಗಳ ಅವಲೋಕನ",
    "business_management": "ವ್ಯಾಪಾರ ನಿರ್ವಹಣೆ",
    "inventory_management": "ಸರಕು ನಿರ್ವಹಣೆ",
    "inventory_management_subtitle": "ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಸ್ಟಾಕ್ ನಿರ್ವಹಿಸಿ",
    "order_management": "ಆದೇಶ ನಿರ್ವಹಣೆ",
    "order_management_subtitle": "ಆದೇಶಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ಪೂರೈಸಿ",
    "purchase_management": "ಖರೀದಿ ನಿರ್ವಹಣೆ",
    "purchase_management_subtitle": "ಖರೀದಿಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ನಿರ್ವಹಿಸಿ",
    "customer_management": "ಗ್ರಾಹಕ ನಿರ್ವಹಣೆ",
    "customer_management_subtitle": "ಗ್ರಾಹಕ ಸಂಬಂಧಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    "supplier_management": "ಪೂರೈಕೆದಾರ ನಿರ್ವಹಣೆ",
    "supplier_management_subtitle": "ಪೂರೈಕೆದಾರ ಸಂಬಂಧಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    "business_analytics": "ವ್ಯಾಪಾರ ವಿಶ್ಲೇಷಣೆ",
    "business_analytics_subtitle": "ಕಾರ್ಯಕ್ಷಮತೆ ಮೆಟ್ರಿಕ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ"
  },
  settings: {
    "settingsTitle": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "inventorySection": "ಇನ್ವೆಂಟರಿ",
    "lowStockThresholdLabel": "ಕಡಿಮೆ ಸ್ಟಾಕ್ ಮಿತಿ",
    "lowStockThresholdDescription": "ಎಚ್ಚರಿಕೆ ಪ್ರಚೋದಿಸುವ ಮೊದಲು ಕನಿಷ್ಠ ಸ್ಟಾಕ್ ಮಟ್ಟ.",
    "stockAlertsLabel": "ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆಗಳು",
    "stockAlertsDescription": "ಕಡಿಮೆ ಸ್ಟಾಕ್‌ಗಾಗಿ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
    "autoReorderLabel": "ಸ್ವಯಂ ಮರು-ಆದೇಶ",
    "autoReorderDescription": "ಸ್ಟಾಕ್ ಕಡಿಮೆಯಾದಾಗ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಖರೀದಿ ಆದೇಶಗಳನ್ನು ರಚಿಸಿ.",
    "ordersSection": "ಆದೇಶಗಳು",
    "autoConfirmOrdersLabel": "ಆದೇಶಗಳನ್ನು ಸ್ವಯಂ-ದೃಢೀಕರಿಸಿ",
    "autoConfirmOrdersDescription": "ಒಳಬರುವ ಆದೇಶಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಅನುಮೋದಿಸಿ ಮತ್ತು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿ.",
    "defaultPaymentMethodLabel": "ಡೀಫಾಲ್ಟ್ ಪಾವತಿ ವಿಧಾನ",
    "defaultPaymentMethodDescription": "ಹೊಸ ಆದೇಶಗಳಿಗಾಗಿ ಡೀಫಾಲ್ಟ್ ಪಾವತಿ ವಿಧಾನವನ್ನು ಹೊಂದಿಸಿ.",
    "orderNumberPrefixLabel": "ಆದೇಶ ಸಂಖ್ಯೆ ಪೂರ್ವಪ್ರತ್ಯಯ",
    "orderNumberPrefixDescription": "ಎಲ್ಲಾ ಆದೇಶ ಸಂಖ್ಯೆಗಳಿಗೆ ಕಸ್ಟಮ್ ಪೂರ್ವಪ್ರತ್ಯಯ (ಉದಾ., 'ORD-').",
    "invoicingSection": "ಸರಕುಪಟ್ಟಿ",
    "autoGenerateInvoicesLabel": "ಸರಕುಪಟ್ಟಿಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಿ",
    "autoGenerateInvoicesDescription": "ಪ್ರತಿ ಆದೇಶಕ್ಕಾಗಿ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಹೊಸ ಸರಕುಪಟ್ಟಿಯನ್ನು ರಚಿಸಿ.",
    "invoiceNumberPrefixLabel": "ಸರಕುಪಟ್ಟಿ ಸಂಖ್ಯೆ ಪೂರ್ವಪ್ರತ್ಯಯ",
    "invoiceNumberPrefixDescription": "ಎಲ್ಲಾ ಸರಕುಪಟ್ಟಿ ಸಂಖ್ಯೆಗಳಿಗೆ ಕಸ್ಟಮ್ ಪೂರ್ವಪ್ರತ್ಯಯ (ಉದಾ., 'INV-').",
    "defaultTaxRateLabel": "ಡೀಫಾಲ್ಟ್ ತೆರಿಗೆ ದರ (%)",
    "defaultTaxRateDescription": "ಹೊಸ ಸರಕುಪಟ್ಟಿಗಳಿಗೆ ಅನ್ವಯವಾಗುವ ಡೀಫಾಲ್ಟ್ ತೆರಿಗೆ ದರ.",
    "paymentTermsLabel": "ಪಾವತಿ ನಿಯಮಗಳು",
    "paymentTermsDescription": "ಸರಕುಪಟ್ಟಿಗಳಿಗಾಗಿ ಡೀಫಾಲ್ಟ್ ಪಾವತಿ ನಿಯಮಗಳು (ಉದಾ., 'ನೆಟ್ 30').",
    "reportingSection": "ವರದಿ ಮಾಡುವಿಕೆ",
    "autoEmailReportsLabel": "ವರದಿಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಇಮೇಲ್ ಮಾಡಿ",
    "autoEmailReportsDescription": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸಕ್ಕೆ ನಿಗದಿತ ವರದಿಗಳನ್ನು ಕಳುಹಿಸಿ.",
    "defaultReportPeriodLabel": "ಡೀಫಾಲ್ಟ್ ವರದಿ ಅವಧಿ",
    "defaultReportPeriodDescription": "ಎಲ್ಲಾ ವರದಿಗಳಿಗೆ ಡೀಫಾಲ್ಟ್ ಅವಧಿಯನ್ನು ಹೊಂದಿಸಿ (ಉದಾ., 'ಮಾಸಿಕ', 'ಸಾಪ್ತಾಹಿಕ').",
    "reportFormatLabel": "ವರದಿ ಸ್ವರೂಪ",
    "reportFormatDescription": "ವರದಿಗಳಿಗಾಗಿ ಡೀಫಾಲ್ಟ್ ಫೈಲ್ ಸ್ವರೂಪವನ್ನು ಆರಿಸಿ (ಉದಾ., 'ಪಿಡಿಎಫ್', 'ಸಿಎಸ್ವಿ').",
    "loadSettingsError": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ: {{message}}",
    "updateFailedError": "ನವೀಕರಣ ವಿಫಲವಾಗಿದೆ",
    "invalidInputError": "ಅಮಾನ್ಯ ಇನ್‌ಪುಟ್",
    "enterValidNumberError": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
    "selectOption": "ಆಯ್ಕೆ ಮಾಡಿ",
    "paymentMethodCash": "ನಗದು",
    "paymentMethodCard": "ಕಾರ್ಡ್",
    "paymentMethodUPI": "ಯುಪಿಐ",
    "paymentMethodBankTransfer": "ಬ್ಯಾಂಕ್ ವರ್ಗಾವಣೆ",
    "reportPeriodDaily": "ದೈನಂದಿನ",
    "reportPeriodWeekly": "ಸಾಪ್ತಾಹಿಕ",
    "reportPeriodMonthly": "ಮಾಸಿಕ",
    "reportPeriodQuarterly": "ತ್ರೈಮಾಸಿಕ",
    "reportFormatPDF": "ಪಿಡಿಎಫ್",
    "reportFormatExcel": "ಎಕ್ಸೆಲ್",
    "reportFormatCSV": "ಸಿಎಸ್ವಿ",
    "enterValuePlaceholder": "ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿ"
  },
  businessProfile: {
    "no_business_profile": "ಯಾವುದೇ ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ಇಲ್ಲ",
    "no_business_profile_description": "ನೀವು ಇನ್ನೂ ನಿಮ್ಮ ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಹೊಂದಿಸಿಲ್ಲ ಎಂದು ತೋರುತ್ತದೆ.",
    "create_business_profile": "ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
    "failed_to_fetch_business_profile": "ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ತರಲು ವಿಫಲವಾಗಿದೆ",
    "could_not_fetch_business_profile": "ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ತರಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "flower_vendor": "ಹೂವಿನ ವ್ಯಾಪಾರಿ",
    "grocery_store": "ದಿನಸಿ ಅಂಗಡಿ",
    "textile_shop": "ಜವಳಿ ಅಂಗಡಿ",
    "hardware_store": "ಹಾರ್ಡ್‌ವೇರ್ ಅಂಗಡಿ",
    "electronics_shop": "ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಅಂಗಡಿ"
  },
  businessSettings: {
    "businessSettings": "ವ್ಯಾಪಾರ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "currency": "ಕರೆನ್ಸಿ",
    "setCurrency": "ನಿಮ್ಮ ವ್ಯಾಪಾರಕ್ಕಾಗಿ ಡೀಫಾಲ್ಟ್ ಕರೆನ್ಸಿಯನ್ನು ಹೊಂದಿಸಿ.",
    "language": "ಭಾಷೆ",
    "setLanguage": "ನಿಮ್ಮ ಖಾತೆಗಾಗಿ ಭಾಷೆಯನ್ನು ಹೊಂದಿಸಿ.",
    "timezone": "ಸಮಯವಲಯ",
    "setTimezone": "ನಿಮ್ಮ ವ್ಯಾಪಾರಕ್ಕಾಗಿ ಸಮಯವಲಯವನ್ನು ಹೊಂದಿಸಿ.",
    "notifications": "ಅಧಿಸೂಚನೆಗಳು",
    "lowStockAlerts": "ಕಡಿಮೆ ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆಗಳು",
    "lowStockDescription": "ಕಡಿಮೆ ಸ್ಟಾಕ್ ಐಟಂಗಳಿಗಾಗಿ ಎಚ್ಚರಿಕೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
    "expiringItems": "ಅವಧಿ ಮುಗಿಯುವ ಐಟಂಗಳು",
    "expiringItemsDescription": "ಅವುಗಳ ಅವಧಿ ಮುಗಿಯುವ ದಿನಾಂಕದ ಸಮೀಪವಿರುವ ಐಟಂಗಳಿಗಾಗಿ ಎಚ್ಚರಿಕೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
    "orderUpdates": "ಆರ್ಡರ್ ನವೀಕರಣಗಳು",
    "orderUpdatesDescription": "ಹೊಸ ಆರ್ಡರ್‌ಗಳು ಮತ್ತು ಆರ್ಡರ್ ಸ್ಥಿತಿ ಬದಲಾವಣೆಗಳಿಗಾಗಿ ಎಚ್ಚರಿಕೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
    "select": "ಆಯ್ಕೆ ಮಾಡಿ",
    "updateFailed": "ನವೀಕರಣ ವಿಫಲವಾಗಿದೆ",
    "loadingError": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "inr": "ಭಾರತೀಯ ರೂಪಾಯಿ (INR)",
    "usd": "ಯುಎಸ್ ಡಾಲರ್ (USD)",
    "en": "ಆಂಗ್ಲ",
    "hi": "ಹಿಂದಿ",
    "te": "ತೆಲುಗು",
    "ta": "ತಮಿಳು",
    "kn": "ಕನ್ನಡ",
    "ml": "ಮಲಯಾಳಂ",
    "kolkata": "ಏಷ್ಯಾ/ಕೋಲ್ಕತ್ತಾ"
  },
  profile: {
    "profile": "ಪ್ರೊಫೈಲ್",
    "manage_your_account_settings": "ನಿಮ್ಮ ಖಾತೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    "active": "ಸಕ್ರಿಯ",
    "business": "ವ್ಯಾಪಾರ",
    "business_profile": "ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್",
    "business_settings": "ವ್ಯಾಪಾರ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "subscription": "ಚಂದಾದಾರಿಕೆ",
    "reports_and_analytics": "ವರದಿಗಳು ಮತ್ತು ವಿಶ್ಲೇಷಣೆಗಳು",
    "account": "ಖಾತೆ",
    "edit_profile": "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    "security_and_privacy": "ಭದ್ರತೆ ಮತ್ತು ಗೌಪ್ಯತೆ",
    "settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "preferences": "ಆದ್ಯತೆಗಳು",
    "advance_view": "ಅಡ್ವಾನ್ಸ್ ವೀಕ್ಷಣೆ",
    "help_and_support": "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ",
    "about_soma": "ಸೋಮಾ ಬಗ್ಗೆ",
    "sign_out": "ಸೈನ್ ಔಟ್ ಮಾಡಿ",
    "logout": "ಲಾಗ್ ಔಟ್",
    "are_you_sure_you_want_to_logout": "ನೀವು ಖಚಿತವಾಗಿ ಲಾಗ್ ಔಟ್ ಮಾಡಲು ಬಯಸುವಿರಾ?"
  },
  dashboard: {
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    business_overview: "ವ್ಯಾಪಾರ ಅವಲೋಕನ",
    action_required: "ಕ್ರಮ ಅಗತ್ಯವಿದೆ",
    profile_incomplete_message: "ನಿಮ್ಮ ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್ ಅಪೂರ್ಣವಾಗಿದೆ. ಮುಂದುವರಿಸಲು ದಯವಿಟ್ಟು ಅಗತ್ಯವಿರುವ ವಿವರಗಳನ್ನು ಒದಗಿಸಿ.",
    complete_profile: "ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ",
    quick_actions: "ತ್ವರಿತ ಕ್ರಮಗಳು",
    add_sale: "ಮಾರಾಟ ಸೇರಿಸಿ",
    manage_stock: "ಸ್ಟಾಕ್ ನಿರ್ವಹಿಸಿ",
    view_orders: "ಆರ್ಡರ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    todays_overview: "ಇಂದಿನ ಅವಲೋಕನ",
    weeks_overview: "ಈ ವಾರದ ಅವಲೋಕನ",
    months_overview: "ಈ ತಿಂಗಳ ಅವಲೋಕನ",
    low_stock: "ಕಡಿಮೆ ಸ್ಟಾಕ್",
    business_management: "ವ್ಯಾಪಾರ ನಿರ್ವಹಣೆ",
    inventory_management_subtitle: "ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಸ್ಟಾಕ್ ನಿರ್ವಹಿಸಿ",
    order_management_subtitle: "ಆರ್ಡರ್‌ಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ಪೂರೈಸಿ",
    purchase_management_subtitle: "ಖರೀದಿಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ನಿರ್ವಹಿಸಿ",
    customer_management_subtitle: "ಗ್ರಾಹಕ ಸಂಬಂಧಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    supplier_management_subtitle: "ಪೂರೈಕೆದಾರ ಸಂಬಂಧಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    business_analytics_subtitle: "ಕಾರ್ಯಕ್ಷಮತೆ ಮೆಟ್ರಿಕ್ಸ್ ವೀಕ್ಷಿಸಿ",
    welcome_back: "ಮರಳಿ ಸ್ವಾಗತ",
    orders_need_attention: "ಗಮನ ಹರಿಸಬೇಕಾದ ಆರ್ಡರ್‌ಗಳು",
    total_revenue: "ಒಟ್ಟು ಆದಾಯ",
    active_orders: "ಸಕ್ರಿಯ ಆರ್ಡರ್‌ಗಳು",
    stock_value: "ಸ್ಟಾಕ್ ಮೌಲ್ಯ",
    total_customers: "ಒಟ್ಟು ಗ್ರಾಹಕರು",
    live: "ಲೈವ್",
    monthly_sales: "ಮಾಸಿಕ ಮಾರಾಟ",
    view_details: "ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    recent_orders: "ಇತ್ತೀಚಿನ ಆರ್ಡರ್‌ಗಳು",
    view_all: "ಎಲ್ಲವನ್ನೂ ವೀಕ್ಷಿಸಿ",
    order_id: "ಆರ್ಡರ್ ಐಡಿ",
    customer: "ಗ್ರಾಹಕ",
    amount: "ಮೊತ್ತ",
    status: "ಸ್ಥಿತಿ",
    important_tasks: "ಪ್ರಮುಖ ಕಾರ್ಯಗಳು",
    in_stock: "ಸ್ಟಾಕ್‌ನಲ್ಲಿದೆ",
    buy_more: "ಇನ್ನಷ್ಟು ಖರೀದಿಸಿ",
    manage_inventory: "ಇನ್ವೆಂಟರಿ ನಿರ್ವಹಣೆ",
    goals: "ಗುರಿಗಳು",
    sales_goal: "ಮಾರಾಟ ಗುರಿ",
    revenue_goal: "ಆದಾಯ ಗುರಿ",
    search_placeholder: "ಆರ್ಡರ್‌ಗಳು, ಗ್ರಾಹಕರು ಅಥವಾ ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ...",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ..."
  },
  analytics: {
    title: "ಅನಾಲಿಟಿಕ್ಸ್",
    subtitle: "ವ್ಯಾಪಾರ ಕಾರ್ಯಕ್ಷಮತೆ ಒಳನೋಟಗಳು",
    last_7_days: "ಕಳೆದ 7 ದಿನಗಳು",
    last_30_days: "ಕಳೆದ 30 ದಿನಗಳು",
    last_3_months: "ಕಳೆದ 3 ತಿಂಗಳುಗಳು",
    business_reports: "ವ್ಯಾಪಾರ ವರದಿಗಳು",
    sales_forecast: "ಮಾರಾಟ ಮುನ್ಸೂಚನೆ",
    reports_library: "ವರದಿ ಲೈಬ್ರರಿ",
    total_revenue: "ಒಟ್ಟು ಆದಾಯ",
    average_order_value: "ಸರಾಸರಿ ಆರ್ಡರ್ ಮೌಲ್ಯ",
    growth_rate: "ಬೆಳವಣಿಗೆ ದರ",
    total_orders: "ಒಟ್ಟು ಆರ್ಡರ್‌ಗಳು",
    sales_by_channel: "ಚಾನೆಲ್ ಮೂಲಕ ಮಾರಾಟ",
    sales_breakdown: "ಮಾರಾಟದ ವಿವರ",
    online_sales: "ಆನ್‌ಲೈನ್ ಮಾರಾಟ",
    store_sales: "ಸ್ಟೋರ್ ಮಾರಾಟ",
    wholesale_sales: "ಸಗಟು ಮಾರಾಟ",
    ai_suggestions: "AI ಸಲಹೆಗಳು",
    ai_insight_1: "ಇನ್ವೆಂಟರಿ ಆಪ್ಟಿಮೈಸೇಶನ್",
    ai_insight_1_desc: "ಸ್ಟಾಕ್‌ಔಟ್‌ಗಳನ್ನು ತಡೆಯಲು 'ಪ್ರೀಮಿಯಂ ಸಿಲ್ಕ್ ಸೀರೆ'ಯನ್ನು ಮರುಕ್ರಮಗೊಳಿಸುವುದನ್ನು ಪರಿಗಣಿಸಿ.",
    next_month: "ಮುಂದಿನ ತಿಂಗಳು",
    next_3_months: "ಮುಂದಿನ 3 ತಿಂಗಳುಗಳು",
    accuracy: "ನಿಖರತೆ",
    sales_growth: "ಮಾರಾಟ ಬೆಳವಣಿಗೆ",
    sales_growth_subtitle: "ಕಳೆದ ತಿಂಗಳಿಗೆ ಹೋಲಿಸಿದರೆ ಅಂದಾಜು ಬೆಳವಣಿಗೆ",
    search_reports: "ವರದಿ ಟೆಂಪ್ಲೇಟ್‌ಗಳನ್ನು ಹುಡುಕಿ...",
    reports_available: "ವರದಿಗಳು ಲಭ್ಯವಿದೆ",
    no_reports: "ಯಾವುದೇ ವರದಿಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    no_reports_desc: "ಬೇರೆ ಹುಡುಕಾಟ ಪದಗಳನ್ನು ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಹೊಸ ಕಸ್ಟಮ್ ವರದಿಯನ್ನು ರಚಿಸಿ.",
    report_name: "ವರದಿ ಹೆಸರು",
    system_default: "ಸಿಸ್ಟಮ್ ಡೀಫಾಲ್ಟ್",
    description: "ವಿವರಣೆ",
    actions: "ಕ್ರಮಗಳು",
    edit: "ತಿದ್ದುಪಡಿ",
    generate: "ರಚಿಸಿ"
  },

  security_page: {
  hero_badge: "ಭದ್ರತೆ",
  hero_title: "ಬ್ಯಾಂಕ್-ಮಟ್ಟದ ಭದ್ರತೆ",
  hero_subtitle: "ನಿಮ್ಮ ವ್ಯವಹಾರಕ್ಕಾಗಿ.",
  hero_desc: "ನಿಮ್ಮ ವ್ಯವಹಾರದ ಡೇಟಾವನ್ನು ಎಂಟರ್‌ಪ್ರೈಸ್-ಮಟ್ಟದ ಭದ್ರತಾ ಕ್ರಮಗಳಿಂದ ರಕ್ಷಿಸಲಾಗಿದೆ. ನಾವು ಭದ್ರತೆಯನ್ನು ಅತ್ಯಂತ ಗಂಭೀರವಾಗಿ ತೆಗೆದುಕೊಳ್ಳುತ್ತೇವೆ ಮತ್ತು ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಸುರಕ್ಷಿತವಾಗಿರಿಸಲು ನಿರಂತರವಾಗಿ ಹೂಡಿಕೆ ಮಾಡುತ್ತೇವೆ.",
  measures_title: "ನಮ್ಮ ಭದ್ರತಾ ಕ್ರಮಗಳು",
  measures_desc: "ಬಹುಮಟ್ಟದ ಭದ್ರತಾ ಪದರಗಳು ಪ್ರತಿಯೊಂದು ಹಂತದಲ್ಲೂ ನಿಮ್ಮ ಡೇಟಾವನ್ನು ರಕ್ಷಿಸುತ್ತವೆ.",
  compliance_title: "ಅನುಸರಣೆ ಮತ್ತು ಪ್ರಮಾಣಪತ್ರಗಳು",
  compliance_desc: "ನಾವು ಅತ್ಯುನ್ನತ ಅನುಸರಣೆ ಮಾನದಂಡಗಳು ಮತ್ತು ಭದ್ರತಾ ಪ್ರಮಾಣಪತ್ರಗಳನ್ನು ಕಾಪಾಡಿಕೊಂಡಿದ್ದೇವೆ.",
  best_practices_title: "ಭದ್ರತಾ ಉತ್ತಮ ಪದ್ಧತಿಗಳು",
  best_practices_desc: "ಈ ಉತ್ತಮ ಪದ್ಧತಿಗಳನ್ನು ಅನುಸರಿಸುವ ಮೂಲಕ ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಸುರಕ್ಷಿತವಾಗಿರಿಸಲು ನಮಗೆ ಸಹಾಯ ಮಾಡಿ:",
  reporting_title: "ಭದ್ರತಾ ಸಮಸ್ಯೆಗಳ ವರದಿ",
  reporting_desc: "ನೀವು ಯಾವುದೇ ಭದ್ರತಾ ದೌರ್ಬಲ್ಯವನ್ನು ಕಂಡುಹಿಡಿದಿದ್ದರೆ ಅಥವಾ ಭದ್ರತೆ ಕುರಿತು ಚಿಂತೆಗಳಿದ್ದರೆ, ದಯವಿಟ್ಟು ತಕ್ಷಣವೇ ನಮಗೆ ವರದಿ ಮಾಡಿ.",
  responsible_disclosure: "ಜವಾಬ್ದಾರಿಯುತ ಬಹಿರಂಗಪಡಿಕೆ",
  responsible_disclosure_desc: "ಭದ್ರತಾ ದೌರ್ಬಲ್ಯಗಳ ಜವಾಬ್ದಾರಿಯುತ ಬಹಿರಂಗಪಡಿಕೆಯನ್ನು ನಾವು ಮೆಚ್ಚುತ್ತೇವೆ. ದಯವಿಟ್ಟು ಭದ್ರತಾ ವಿವರಗಳನ್ನು ಈ ಇಮೇಲ್‌ಗೆ ಕಳುಹಿಸಿ:",
  contact_team: "ಭದ್ರತಾ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ",
  view_privacy: "ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ವೀಕ್ಷಿಸಿ",
  priority_title: "ನಿಮ್ಮ ಭದ್ರತೆ ನಮ್ಮ ಆದ್ಯತೆ",
  priority_desc: "ನಿಮ್ಮ ವ್ಯವಹಾರ ಡೇಟಾವನ್ನು ರಕ್ಷಿಸಲು ನಾವು ಭದ್ರತಾ ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಉತ್ತಮ ಪದ್ಧತಿಗಳಲ್ಲಿ ನಿರಂತರವಾಗಿ ಹೂಡಿಕೆ ಮಾಡುತ್ತೇವೆ. ಭದ್ರತೆ ಕುರಿತು ಪ್ರಶ್ನೆಗಳಿದೆಯೇ? ನಾವು ಸಹಾಯ ಮಾಡಲು ಇಲ್ಲಿದ್ದೇವೆ."
},

  billing_page: {
    title: "ಹಣಕಾಸು ಮತ್ತು ಬಿಲ್ಲಿಂಗ್",
    subtitle: "ಕಾರ್ಪೊರೇಟ್ ಚಂದಾದಾರಿಕೆಗಳು ಮತ್ತು ಸಂಪನ್ಮೂಲ ಇತ್ಯರ್ಥಕ್ಕಾಗಿ ಆರ್ಕಿಟೆಕ್ಚರ್",
    tabs: {
      subscription: "ಚಂದಾದಾರಿಕೆ",
      history: "ಇತಿಹಾಸ",
      settlements: "ಇತ್ಯರ್ಥಗಳು",
      corporate_profile: "ಕಾರ್ಪೊರೇಟ್ ಪ್ರೊಫೈಲ್"
    },
    subscription: {
      tier_status: "ಶ್ರೇಣಿ ಸ್ಥಿತಿ",
      authenticated: "ದೃಢೀಕರಿಸಲಾಗಿದೆ",
      renewal: "ನವೀಕರಣ: ",
      ascend_plan: "ಪ್ಲಾನ್ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
      equilibrium_method: "ಸಮತೋಲನ ವಿಧಾನ",
      recent_settlement: "ಇತ್ತೀಚಿನ ಇತ್ಯರ್ಥ",
      verified: "ಪರಿಶೀಲಿಸಲಾಗಿದೆ"
    },
    history: {
      invoice_identifier: "ಇನ್ವಾಯ್ಸ್ ಗುರುತಿಸುವಿಕೆ",
      issuance_date: "ನೀಡಿಕೆಯ ದಿನಾಂಕ",
      settlement_amount: "ಇತ್ಯರ್ಥ ಮೊತ್ತ",
      status: "ಸ್ಥಿತಿ",
      actions: "ಕ್ರಿಯೆಗಳು",
      no_history_title: "ಯಾವುದೇ ಇತ್ಯರ್ಥ ಇತಿಹಾಸವಿಲ್ಲ",
      no_history_desc: "ದೃಢೀಕರಣದ ನಂತರ ನಿಮ್ಮ ಪರಿಶೀಲಿಸಿದ ಇನ್ವಾಯ್ಸ್‌ಗಳು ಇಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತವೆ."
    },
    settlements: {
      architecture_title: "ಇತ್ಯರ್ಥ ಆರ್ಕಿಟೆಕ್ಚರ್",
      architecture_desc: "ಅಧಿಕೃತ ಕಾರ್ಪೊರೇಟ್ ಪ್ರವೇಶ ಬಿಂದುಗಳು",
      initialize_method: "ವಿಧಾನವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
      no_vectors: "ಯಾವುದೇ ಇತ್ಯರ್ಥ ವೆಕ್ಟರ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ"
    },
    profile: {
      corporate_identity: "ಕಾರ್ಪೊರೇಟ್ ಗುರುತು",
      tax_protocol: "ತೆರಿಗೆ ಪ್ರೋಟೋಕಾಲ್ / GSTIN",
      registered_address: "ನೋಂದಾಯಿತ ವಿಳಾಸ",
      metropolis: "ನಗರ",
      jurisdiction: "ಅಧಿಕಾರ ವ್ಯಾಪ್ತಿ",
      postal_code: "ಪಿನ್ ಕೋಡ್",
      sovereignty: "ಸಾರ್ವಭೌಮತ್ವ",
      synchronizing: "ಸಿಂಕ್ರೊನೈಸ್ ಆಗುತ್ತಿದೆ...",
      authorize_updates: "ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಅಧಿಕೃತಗೊಳಿಸಿ",
      update_success: "ಬಿಲ್ಲಿಂಗ್ ಮಾಹಿತಿಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ"
    }
  },
  gst_page: {
    tax_gst: "ತೆರಿಗೆ ಮತ್ತು ಜಿಎಸ್‌ಟಿ",
    manage_gst: "ನಿಮ್ಮ ಜಿಎಸ್‌ಟಿ ರಿಟರ್ನ್ಸ್ ಮತ್ತು ತೆರಿಗೆ ಅನುಸರಣೆಯನ್ನು ನಿರ್ವಹಿಸಿ",
    export_report: "ತೆರಿಗೆ ವರದಿಯನ್ನು ರಫ್ತು ಮಾಡಿ",
    input_tax_credit: "ಇನ್‌ಪುಟ್ ತೆರಿಗೆ ಕ್ರೆಡಿಟ್",
    tax_liability: "ತೆರಿಗೆ ಹೊಣೆಗಾರಿಕೆ",
    pending_returns: "ಬಾಕಿ ಇರುವ ರಿಟರ್ನ್ಸ್",
    compliance_score: "ಅನುಸರಣೆ ಸ್ಕೋರ್",
    gstin_check: "ಜಿಎಸ್‌ಟಿಐಎನ್ ಪರಿಶೀಲನೆ",
    gst_returns: "ಜಿಎಸ್‌ಟಿ ರಿಟರ್ನ್ಸ್",
    auto_file_gst: "ಆಟೋ ಫೈಲ್ ಜಿಎಸ್‌ಟಿ",
    past_returns: "ಹಿಂದಿನ ರಿಟರ್ನ್ಸ್",
    gstin_verification: "ಜಿಎಸ್‌ಟಿಐಎನ್ ದೃಢೀಕರಣ",
    verify_gst_desc: "ಸರ್ಕಾರಿ ಡೇಟಾಬೇಸ್‌ನೊಂದಿಗೆ ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ.",
    verify_gst_subdesc: "ಯಾವುದೇ 15-ಅಂಕಿಯ ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆಯನ್ನು ತ್ವರಿತವಾಗಿ ಪರಿಶೀಲಿಸಿ.",
    enter_gst_number: "15-ಅಂಕಿಯ ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ...",
    check_gst_number: "ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
    checking: "ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...",
    gst_verified: "ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆ ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    verified_successfully: "ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    business_name: "ವ್ಯಾಪಾರದ ಹೆಸರು",
    state: "ರಾಜ್ಯ",
    invalid_gst_number: "ಅಮಾನ್ಯ ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆ",
    gst_not_valid: "ಜಿಎಸ್‌ಟಿ ಸಂಖ್ಯೆ ಮಾನ್ಯವಾಗಿಲ್ಲ",
    all_returns_filed: "ಎಲ್ಲಾ ರಿಟರ್ನ್ಸ್ ಸಲ್ಲಿಸಲಾಗಿದೆ",
    returns_up_to_date: "ನಿಮ್ಮ ಜಿಎಸ್‌ಟಿ ರಿಟರ್ನ್ಸ್ ನವೀಕೃತವಾಗಿವೆ",
    gstr1_sales: "GSTR-1 (ಮಾರಾಟ)",
    feature_auto_pop: "ವೈಶಿಷ್ಟ್ಯ: ಇನ್ವಾಯ್ಸ್‌ಗಳಿಂದ ಸ್ವಯಂ-ಜನಸಂಖ್ಯೆ",
    coming_soon: "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
    gstr3b_summary: "GSTR-3B (ಸಾರಾಂಶ)",
    feature_liability: "ವೈಶಿಷ್ಟ್ಯ: ಒಂದು ಕ್ಲಿಕ್ ಹೊಣೆಗಾರಿಕೆ ಆಫ್‌ಸೆಟ್",
    history_coming_soon: "ಇತಿಹಾಸ ವೈಶಿಷ್ಟ್ಯ ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ.",
    return_type: "ರಿಟರ್ನ್ ಪ್ರಕಾರ",
    period: "ಅವಧಿ",
    due_date: "ಗಡುವು ದಿನಾಂಕ",
    status: "ಸ್ಥಿತಿ",
    actions: "ಕ್ರಿಯೆಗಳು",
    submit_return: "ರಿಟರ್ನ್ ಸಲ್ಲಿಸಿ",
    active: "ಸಕ್ರಿಯ",
    due: "ಬಾಕಿ",
    maharashtra: "ಮಹಾರಾಷ್ಟ್ರ"
  },
  orders_page: {
    title: "ಆದೇಶಗಳು",
    description: "ನಿಮ್ಮ ಎಲ್ಲಾ ಆದೇಶಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    create_new_order: "ಹೊಸ ಆದೇಶವನ್ನು ರಚಿಸಿ",
    total_orders: "ಒಟ್ಟು ಆದೇಶಗಳು",
    pending_orders: "ಬಾಕಿ ಇರುವ ಆದೇಶಗಳು",
    completed_orders: "ಪೂರ್ಣಗೊಂಡ ಆದೇಶಗಳು",
    direct_sales: "ನೇರ ಮಾರಾಟ",
    search_placeholder: "ಆದೇಶ ಐಡಿ ಅಥವಾ ಗ್ರಾಹಕರ ಹೆಸರಿನ ಮೂಲಕ ಹುಡುಕಿ...",
    filter_all: "ಎಲ್ಲಾ",
    filter_pending: "ಬಾಕಿ ಉಳಿದಿದೆ",
    filter_completed: "ಪೂರ್ಣಗೊಂಡಿದೆ",
    no_orders: "ಯಾವುದೇ ಆದೇಶಗಳಿಲ್ಲ",
    no_orders_desc: "ಯಾವುದೇ ಆದೇಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    delete_confirmation: "ಈ ಆದೇಶವನ್ನು ಅಳಿಸಬೇಕೇ?",
    col_order_id: "ಆದೇಶ ಐಡಿ",
    col_customer_name: "ಗ್ರಾಹಕರ ಹೆಸರು",
    guest: "ಅತಿಥಿ",
    col_order_status: "ಆದೇಶ ಸ್ಥಿತಿ",
    standard: "ಸ್ಟ್ಯಾಂಡರ್ಡ್",
    col_amount: "ಮೊತ್ತ",
    total: "ಒಟ್ಟು",
    col_actions: "ಕ್ರಿಯೆಗಳು",
    wire: "ವೈರ್",
    error_loading_sample: "ಲೋಡ್ ಆಗುತ್ತಿದೆ... ಮಾದರಿ ಡೇಟಾವನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ"
  },
  purchases_page: {
    purchases: "ಖರೀದಿಗಳು",
    manage_purchases: "ನಿಮ್ಮ ಖರೀದಿಗಳು ಮತ್ತು ಪಾವತಿಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    add_purchase: "ಖರೀದಿಯನ್ನು ಸೇರಿಸಿ",
    total_purchases: "ಒಟ್ಟು ಖರೀದಿಗಳು",
    total_spent: "ಒಟ್ಟು ಖರ್ಚು",
    pending_purchases: "ಬಾಕಿ ಇರುವ ಖರೀದಿಗಳು",
    pending_payment: "ಬಾಕಿ ಪಾವತಿ",
    search_placeholder: "ಸರಬರಾಜುದಾರರ ಹೆಸರು ಅಥವಾ ಖರೀದಿ ಐಡಿ ಮೂಲಕ ಹುಡುಕಿ...",
    all: "ಎಲ್ಲಾ",
    pending: "ಬಾಕಿ ಉಳಿದಿದೆ",
    unpaid: "ಪಾವತಿಸದ",
    no_purchases: "ಯಾವುದೇ ಖರೀದಿಗಳಿಲ್ಲ",
    no_purchases_desc: "ಯಾವುದೇ ಖರೀದಿಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    id_date: "ಐಡಿ / ದಿನಾಂಕ",
    supplier: "ಸರಬರಾಜುದಾರ",
    amount: "ಮೊತ್ತ",
    before_tax: "ತೆರಿಗೆಗೆ ಮುಂಚಿತವಾಗಿ",
    status: "ಸ್ಥಿತಿ",
    payment_status: "ಪಾವತಿ ಸ್ಥಿತಿ",
    actions: "ಕ್ರಿಯೆಗಳು",
    delete_confirmation: "ಈ ಖರೀದಿಯನ್ನು ಅಳಿಸಬೇಕೇ?",
    paid: "ಪಾವತಿಸಲಾಗಿದೆ",
    partial: "ಭಾಗಶಃ"
  },
  inventory_page: {
    inventory: "ದಾಸ್ತಾನು",
    manage_inventory: "ನಿಮ್ಮ ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಸ್ಟಾಕ್ ಮಟ್ಟವನ್ನು ನಿರ್ವಹಿಸಿ",
    add_product: "ಉತ್ಪನ್ನ ಸೇರಿಸಿ",
    total_items: "ಒಟ್ಟು ವಸ್ತುಗಳು",
    low_stock: "ಕಡಿಮೆ ಸ್ಟಾಕ್",
    out_of_stock: "ಸ್ಟಾಕ್ ಖಾಲಿಯಾಗಿದೆ",
    stock_value: "ಸ್ಟಾಕ್ ಮೌಲ್ಯ",
    search_placeholder: "ಕೋಡ್, ಹೆಸರು ಅಥವಾ ಪ್ರಕಾರದ ಮೂಲಕ ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ...",
    all_items: "ಎಲ್ಲಾ ವಸ್ತುಗಳು",
    product_name: "ಉತ್ಪನ್ನದ ಹೆಸರು",
    product_code: "ಉತ್ಪನ್ನ ಕೋಡ್",
    stock_status: "ಸ್ಟಾಕ್ ಸ್ಥಿತಿ",
    price: "ಬೆಲೆ",
    before_tax: "ತೆರಿಗೆಗೆ ಮುಂಚಿತವಾಗಿ",
    actions: "ಕ್ರಿಯೆಗಳು",
    in_stock: "ಸ್ಟಾಕ್‌ನಲ್ಲಿದೆ",
    units: "ಘಟಕಗಳು",
    delete_confirmation: "ಈ ಉತ್ಪನ್ನವನ್ನು ಅಳಿಸಬೇಕೇ?",
    no_products: "ಯಾವುದೇ ಉತ್ಪನ್ನಗಳಿಲ್ಲ",
    no_products_desc: "ಯಾವುದೇ ಉತ್ಪನ್ನಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    edit_product: "ಉತ್ಪನ್ನವನ್ನು ಸಂಪಾದಿಸಿ",
    delete_product: "ಉತ್ಪನ್ನವನ್ನು ಅಳಿಸಿ",
    loading_sample_data: "ಲೋಡ್ ಆಗುತ್ತಿದೆ... ಮಾದರಿ ಡೇಟಾವನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ"
  },
  locations_page: {
    title: "ಸ್ಥಳಗಳು",
    subtitle: "ಬಹು ಸ್ಥಳಗಳು ಮತ್ತು ಸ್ಟಾಕ್ ವರ್ಗಾವಣೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    transfer_stock: "ಸ್ಟಾಕ್ ವರ್ಗಾವಣೆ",
    add_location: "ಸ್ಥಳ ಸೇರಿಸಿ",
    total_locations: "ಸ್ಥಳಗಳು",
    active_locations: "ಸಕ್ರಿಯ ಸ್ಥಳಗಳು",
    total_stock: "ಒಟ್ಟು ಸ್ಟಾಕ್",
    transfers_progress: "ಪ್ರಗತಿಯಲ್ಲಿರುವ ವರ್ಗಾವಣೆಗಳು",
    tabs: {
      locations: "ಸ್ಥಳಗಳು",
      all_stock: "ಎಲ್ಲಾ ಸ್ಥಳಗಳ ಸ್ಟಾಕ್",
      transfers: "ಸ್ಟಾಕ್ ವರ್ಗಾವಣೆಗಳು",
      analytics: "ಅನಾಲಿಟಿಕ್ಸ್"
    },
    table: {
      location_name: "ಸ್ಥಳದ ಹೆಸರು",
      type: "ಪ್ರಕಾರ",
      address: "ವಿಳಾಸ",
      contact: "ಸಂಪರ್ಕ",
      status: "ಸ್ಥಿತಿ",
      actions: "ಕ್ರಿಯೆಗಳು",
      active: "ಸಕ್ರಿಯ",
      inactive: "ನಿಷ್ಕ್ರಿಯ",
      store: "ಅಂಗಡಿ",
      warehouse: "ಗೋದಾಮು",
      view_details: "ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
      edit: "ಸಂಪಾದಿಸಿ",
      delete: "ಅಳಿಸಿ"
    },
    transfer_table: {
      date: "ವರ್ಗಾವಣೆ ದಿನಾಂಕ",
      date_label: "ದಿನಾಂಕ",
      route: "ಇಂದ → ಗೆ"
    },
    empty_state: {
      no_locations: "ಯಾವುದೇ ಸ್ಥಳಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
      no_locations_desc: "ನೀವು ಇನ್ನೂ ಯಾವುದೇ ಸ್ಥಳಗಳನ್ನು ಸೇರಿಸಿಲ್ಲ. ಪ್ರಾರಂಭಿಸಲು ಅಂಗಡಿ ಅಥವಾ ಗೋದಾಮನ್ನು ಸೇರಿಸಿ.",
      no_transfers: "ಯಾವುದೇ ವರ್ಗಾವಣೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
      no_transfers_desc: "ನೀವು ಇನ್ನೂ ಯಾವುದೇ ಸ್ಟಾಕ್ ವರ್ಗಾವಣೆಗಳನ್ನು ಪ್ರಾರಂಭಿಸಿಲ್ಲ.",
      no_stock: "ಯಾವುದೇ ಸ್ಟಾಕ್ ಡೇಟಾ ಇಲ್ಲ",
      no_stock_desc: "ಆಯ್ಕೆಮಾಡಿದ ಸ್ಥಳಕ್ಕೆ ಯಾವುದೇ ಸ್ಟಾಕ್ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ."
    },
    analytics: {
      sales_analysis: "ಮಾರಾಟ ವಿಶ್ಲೇಷಣೆ",
      coming_soon: "ಸುಧಾರಿತ ವಿಶ್ಲೇಷಣೆಗಳು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿವೆ."
    }
  },
  usage_page: {
    title: "ಬಳಕೆ ಮತ್ತು ಮಿತಿಗಳು",
    subtitle: "ನಿಮ್ಮ ಬಳಕೆ ಮತ್ತು ಮಿತಿಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    export_report: "ವರದಿಯನ್ನು ರಫ್ತು ಮಾಡಿ",
    cards: {
      api_calls: "API ಕರೆಗಳು",
      storage_used: "ಶೇಖರಣಾ ಬಳಕೆ",
      data_transfer: "ಡೇಟಾ ವರ್ಗಾವಣೆ",
      processing_time: "ಸಂಸ್ಕರಣಾ ಸಮಯ"
    },
    tabs: {
      system_status: "ಸಿಸ್ಟಮ್ ಸ್ಥಿತಿ",
      usage_limits: "ಬಳಕೆಯ ಮಿತಿಗಳು",
      usage_history: "ಬಳಕೆಯ ಇತಿಹಾಸ",
      alerts: "ಎಚ್ಚರಿಕೆಗಳು"
    },
    monitor: {
      system_health: "ಸಿಸ್ಟಮ್ ಆರೋಗ್ಯ",
      current_system_status: "ಪ್ರಸ್ತುತ ಸಿಸ್ಟಮ್ ಸ್ಥಿತಿ",
      uptime: "ಅಪ್‌ಟೈಮ್",
      response_time: "ಪ್ರತಿಕ್ರಿಯೆ ಸಮಯ",
      errors: "ದೋಷಗಳು",
      database_usage: "ಡೇಟಾಬೇಸ್ ಬಳಕೆ",
      auto_scaling: "ಆಟೋ ಸ್ಕೇಲಿಂಗ್",
      system_running_smoothly: "ಸಿಸ್ಟಮ್ ಸುಗಮವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿದೆ.",
      system_running_desc: "ಬಳಕೆಯ ಆಧಾರದ ಮೇಲೆ ಸಿಸ್ಟಮ್ ಸಂಪನ್ಮೂಲಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ನಿರ್ವಹಿಸುತ್ತಿದೆ. ವೇಗದ ಕಾರ್ಯಕ್ಷಮತೆಗಾಗಿ ಸಿಸ್ಟಮ್ ಉತ್ತಮವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿದೆ.",
      manage_auto_scaling: "ಆಟೋ ಸ್ಕೇಲಿಂಗ್ ನಿರ್ವಹಿಸಿ"
    },
    quotas: {
      usage_limit: "ಬಳಕೆ ಮಿತಿ",
      used: "ಬಳಸಲಾಗಿದೆ",
      total_limit: "ಒಟ್ಟು ಮಿತಿ"
    },
    history: {
      date: "ದಿನಾಂಕ",
      api_calls: "API ಕರೆಗಳು",
      storage: "ಶೇಖರಣೆ",
      data_transfer: "ಡೇಟಾ ವರ್ಗಾವಣೆ",
      reqs: "ವಿನಂತಿಗಳು",
      no_history: "ಯಾವುದೇ ಇತಿಹಾಸವಿಲ್ಲ",
      no_history_desc: "ಬಳಕೆ ಇತಿಹಾಸ ಇಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ"
    },
    alerts: {
      fix_issue: "ಸಮಸ್ಯೆಯನ್ನು ಸರಿಪಡಿಸಿ",
      all_systems_good: "ಎಲ್ಲಾ ಸಿಸ್ಟಮ್‌ಗಳು ಉತ್ತಮವಾಗಿವೆ",
      no_issues_found: "ಯಾವುದೇ ಸಮಸ್ಯೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ"
    }
  },
  sidebar: {
    menu: {
      overview: "ಅವಲೋಕನ",
      business: "ವ್ಯಾಪಾರ",
      finance: "ಹಣಕಾಸು",
      system: "ವ್ಯವಸ್ಥೆ"
    },
    items: {
      dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
      analytics: "ವಿಶ್ಲೇಷಣೆ",
      business_profile: "ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್",
      inventory: "ದಾಸ್ತಾನು",
      orders: "ಆರ್ಡರ್‌ಗಳು",
      purchases: "ಖರೀದಿಗಳು",
      customers: "ಗ್ರಾಹಕರು",
      suppliers: "ಪೂರೈಕೆದಾರರು",
      business_settings: "ವ್ಯಾಪಾರ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
      tax_gst: "ತೆರಿಗೆ ಮತ್ತು GST",
      billing: "ಬಿಲ್ಲಿಂಗ್",
      subscription: "ಚಂದಾದಾರಿಕೆ",
      locations: "ಸ್ಥಳಗಳು",
      settings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
      usage: "ಬಳಕೆ"
    },
    footer: {
      upgrade_pro: "Pro ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
      account: "ಖಾತೆ",
      billing: "ಬಿಲ್ಲಿಂಗ್",
      notifications: "ಅಧಿಸೂಚನೆಗಳು",
      logout: "ಲಾಗ್ ಔಟ್"
    }
  }
};